// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddCollectProjectLanguageData, AddCollectProjectLanguageErrors, AddCollectProjectLanguageResponses, AddCollectProjectRecipientMembersData, AddCollectProjectRecipientMembersErrors, AddCollectProjectRecipientMembersResponses, AddRolloutFacilitatorsData, AddRolloutFacilitatorsErrors, AddRolloutFacilitatorsResponses, AddSynthesisLanguageData, AddSynthesisLanguageErrors, AddSynthesisLanguageResponses, AdmitProviderTestTargetStartData, AdmitProviderTestTargetStartErrors, AdmitProviderTestTargetStartResponses, AdvanceLoadTestAnalysisStatusFixtureData, AdvanceLoadTestAnalysisStatusFixtureErrors, AdvanceLoadTestAnalysisStatusFixtureResponses, AnswerCollectConversationLabelData, AnswerCollectConversationLabelErrors, AnswerCollectConversationLabelResponses, AnswerCollectConversationTextData, AnswerCollectConversationTextErrors, AnswerCollectConversationTextResponses, ArchiveAnalysisRunData, ArchiveAnalysisRunErrors, ArchiveAnalysisRunResponses, ArchiveCollectLensData, ArchiveCollectLensErrors, ArchiveCollectLensResponses, ArchiveCollectProjectData, ArchiveCollectProjectErrors, ArchiveCollectProjectResponses, ArchiveRolloutData, ArchiveRolloutErrors, ArchiveRolloutResponses, ArchiveSynthesisData, ArchiveSynthesisErrors, ArchiveSynthesisResponses, AssignDiscoveryMemberData, AssignDiscoveryMemberErrors, AssignDiscoveryMemberResponses, BreakFacilitationSessionChoiceTieData, BreakFacilitationSessionChoiceTieErrors, BreakFacilitationSessionChoiceTieResponses, CancelAnalysisRunData, CancelAnalysisRunErrors, CancelAnalysisRunResponses, CleanupAnalysisRunsByOrganizationProjectData, CleanupAnalysisRunsByOrganizationProjectErrors, CleanupAnalysisRunsByOrganizationProjectResponses, CleanupCollectProjectsByOrganizationProjectData, CleanupCollectProjectsByOrganizationProjectErrors, CleanupCollectProjectsByOrganizationProjectResponses, CleanupDiscoveriesByOrganizationProjectData, CleanupDiscoveriesByOrganizationProjectErrors, CleanupDiscoveriesByOrganizationProjectResponses, CleanupSynthesesByOrganizationProjectData, CleanupSynthesesByOrganizationProjectErrors, CleanupSynthesesByOrganizationProjectResponses, CloseCollectProjectData, CloseCollectProjectErrors, CloseCollectProjectResponses, CloseFacilitationSessionVoteRoundData, CloseFacilitationSessionVoteRoundErrors, CloseFacilitationSessionVoteRoundResponses, CloseSynthesisVotingData, CloseSynthesisVotingErrors, CloseSynthesisVotingResponses, CountAnalysisRunsByOrganizationProjectData, CountAnalysisRunsByOrganizationProjectErrors, CountAnalysisRunsByOrganizationProjectResponses, CountCollectProjectsByOrganizationProjectData, CountCollectProjectsByOrganizationProjectErrors, CountCollectProjectsByOrganizationProjectResponses, CountDiscoveriesByOrganizationProjectData, CountDiscoveriesByOrganizationProjectErrors, CountDiscoveriesByOrganizationProjectResponses, CountSynthesesByOrganizationProjectData, CountSynthesesByOrganizationProjectErrors, CountSynthesesByOrganizationProjectResponses, CreateCollectLensData, CreateCollectLensErrors, CreateCollectLensResponses, CreateCollectProjectData, CreateCollectProjectErrors, CreateCollectProjectInterviewActivityLinkData, CreateCollectProjectInterviewActivityLinkErrors, CreateCollectProjectInterviewActivityLinkResponses, CreateCollectProjectIntroData, CreateCollectProjectIntroErrors, CreateCollectProjectIntroResponses, CreateCollectProjectRecipientCodesData, CreateCollectProjectRecipientCodesErrors, CreateCollectProjectRecipientCodesResponses, CreateCollectProjectResponses, CreateDiscoveryInOrgProjectData, CreateDiscoveryInOrgProjectErrors, CreateDiscoveryInOrgProjectResponses, CreateDiscoveryRequestData, CreateDiscoveryRequestErrors, CreateDiscoveryRequestResponses, CreateGlobalKitData, CreateGlobalKitErrors, CreateGlobalKitResponses, CreateKitCategoryData, CreateKitCategoryErrors, CreateKitCategoryResponses, CreateKitDraftData, CreateKitDraftErrors, CreateKitDraftResponses, CreateLoadTestAnalysisStatusFixtureData, CreateLoadTestAnalysisStatusFixtureErrors, CreateLoadTestAnalysisStatusFixtureResponses, CreateLoadTestReportFixtureData, CreateLoadTestReportFixtureErrors, CreateLoadTestReportFixtureResponses, CreateOrganizationKitData, CreateOrganizationKitErrors, CreateOrganizationKitResponses, CreateOrganizationResourceData, CreateOrganizationResourceErrors, CreateOrganizationResourceFolderData, CreateOrganizationResourceFolderErrors, CreateOrganizationResourceFolderResponses, CreateOrganizationResourceResponses, CreateProviderTestRunData, CreateProviderTestRunErrors, CreateProviderTestRunResponses, CreateRolloutData, CreateRolloutErrors, CreateRolloutResponses, CreateStandaloneSessionData, CreateStandaloneSessionErrors, CreateStandaloneSessionResponses, CreateSynthesisData, CreateSynthesisErrors, CreateSynthesisResponses, DeleteAllCollectProjectConversationsData, DeleteAllCollectProjectConversationsErrors, DeleteAllCollectProjectConversationsResponses, DeleteAnalysisRunData, DeleteAnalysisRunErrors, DeleteAnalysisRunResponses, DeleteCollectExportConversationsData, DeleteCollectExportConversationsErrors, DeleteCollectExportConversationsResponses, DeleteCollectLensData, DeleteCollectLensErrors, DeleteCollectLensResponses, DeleteCollectProjectData, DeleteCollectProjectErrors, DeleteCollectProjectIntroData, DeleteCollectProjectIntroErrors, DeleteCollectProjectIntroResponses, DeleteCollectProjectResponses, DeleteCollectProjectsByOrganizationProjectData, DeleteCollectProjectsByOrganizationProjectErrors, DeleteCollectProjectsByOrganizationProjectResponses, DeleteDiscoveryData, DeleteDiscoveryErrors, DeleteDiscoveryResponses, DeleteKitCategoryData, DeleteKitCategoryErrors, DeleteKitCategoryResponses, DeleteSynthesesByOrganizationProjectData, DeleteSynthesesByOrganizationProjectErrors, DeleteSynthesesByOrganizationProjectResponses, DeleteSynthesisData, DeleteSynthesisErrors, DeleteSynthesisResponses, DetachFacilitationSessionData, DetachFacilitationSessionErrors, DetachFacilitationSessionResponses, DiscardKitDraftData, DiscardKitDraftErrors, DiscardKitDraftResponses, DownloadAnalysisRunArtifactAdminData, DownloadAnalysisRunArtifactAdminErrors, DownloadAnalysisRunArtifactAdminResponses, EditCollectConversationTextAnswerData, EditCollectConversationTextAnswerErrors, EditCollectConversationTextAnswerResponses, EnsureE2eAnonymousVotingCanvasesData, EnsureE2eAnonymousVotingCanvasesErrors, EnsureE2eAnonymousVotingCanvasesResponses, ExportCollectConversationsData, ExportCollectConversationsErrors, ExportCollectConversationsResponses, FillFacilitationSessionWorksheetData, FillFacilitationSessionWorksheetErrors, FillFacilitationSessionWorksheetResponses, GenerateSynthesisDiscussionQuestionsData, GenerateSynthesisDiscussionQuestionsErrors, GenerateSynthesisDiscussionQuestionsResponses, GetAnalysisCodebookLibraryData, GetAnalysisCodebookLibraryErrors, GetAnalysisCodebookLibraryResponses, GetAnalysisJobAdminData, GetAnalysisJobAdminErrors, GetAnalysisJobAdminResponses, GetAnalysisRunArtifactAdminData, GetAnalysisRunArtifactAdminErrors, GetAnalysisRunArtifactAdminResponses, GetAnalysisRunCodebookData, GetAnalysisRunCodebookErrors, GetAnalysisRunCodebookResponses, GetAnalysisRunData, GetAnalysisRunErrors, GetAnalysisRunOverviewAdminData, GetAnalysisRunOverviewAdminErrors, GetAnalysisRunOverviewAdminResponses, GetAnalysisRunResponses, GetCanvasByIdData, GetCanvasByIdErrors, GetCanvasByIdResponses, GetCanvasParticipationData, GetCanvasParticipationErrors, GetCanvasParticipationResponses, GetCanvasParticipationResultsData, GetCanvasParticipationResultsErrors, GetCanvasParticipationResultsResponses, GetCanvasParticipationViewData, GetCanvasParticipationViewErrors, GetCanvasParticipationViewResponses, GetCanvasViewData, GetCanvasViewErrors, GetCanvasViewInsightsData, GetCanvasViewInsightsErrors, GetCanvasViewInsightsResponses, GetCanvasViewReportData, GetCanvasViewReportErrors, GetCanvasViewReportResponses, GetCanvasViewResponses, GetCanvasVotesResultsData, GetCanvasVotesResultsErrors, GetCanvasVotesResultsResponses, GetCollectConversationData, GetCollectConversationErrors, GetCollectConversationResponses, GetCollectExportConversationSummariesData, GetCollectExportConversationSummariesErrors, GetCollectExportConversationSummariesResponses, GetCollectExportProjectStatisticsData, GetCollectExportProjectStatisticsErrors, GetCollectExportProjectStatisticsResponses, GetCollectLensData, GetCollectLensErrors, GetCollectLensResponses, GetCollectProjectActivityBinsData, GetCollectProjectActivityBinsErrors, GetCollectProjectActivityBinsResponses, GetCollectProjectActivitySummaryData, GetCollectProjectActivitySummaryErrors, GetCollectProjectActivitySummaryResponses, GetCollectProjectByIdData, GetCollectProjectByIdErrors, GetCollectProjectByIdResponses, GetCollectProjectData, GetCollectProjectErrors, GetCollectProjectIntroData, GetCollectProjectIntroErrors, GetCollectProjectIntroResponses, GetCollectProjectRecipientReminderData, GetCollectProjectRecipientReminderErrors, GetCollectProjectRecipientReminderResponses, GetCollectProjectResponses, GetCollectProjectStatisticsData, GetCollectProjectStatisticsErrors, GetCollectProjectStatisticsResponses, GetCollectProjectTemplateData, GetCollectProjectTemplateErrors, GetCollectProjectTemplateResponses, GetCollectProjectTranslationStatusData, GetCollectProjectTranslationStatusErrors, GetCollectProjectTranslationStatusResponses, GetCollectPublicStatsData, GetCollectPublicStatsErrors, GetCollectPublicStatsResponses, GetDiscoveryContextData, GetDiscoveryContextErrors, GetDiscoveryContextResponses, GetDiscoveryImportContextInternalData, GetDiscoveryImportContextInternalErrors, GetDiscoveryImportContextInternalResponses, GetFacilitationSessionData, GetFacilitationSessionDemoData, GetFacilitationSessionDemoErrors, GetFacilitationSessionDemoResponses, GetFacilitationSessionErrors, GetFacilitationSessionResponses, GetFacilitationSessionWorksheetData, GetFacilitationSessionWorksheetErrors, GetFacilitationSessionWorksheetResponses, GetKitData, GetKitDraftData, GetKitDraftErrors, GetKitDraftResponses, GetKitErrors, GetKitHomeTemplateData, GetKitHomeTemplateErrors, GetKitHomeTemplateResponses, GetKitInterviewTemplateData, GetKitInterviewTemplateErrors, GetKitInterviewTemplateResponses, GetKitResponses, GetKitVersionData, GetKitVersionErrors, GetKitVersionHomeData, GetKitVersionHomeErrors, GetKitVersionHomeResponses, GetKitVersionResponses, GetMyCanvasParticipationVotesData, GetMyCanvasParticipationVotesErrors, GetMyCanvasParticipationVotesResponses, GetOrganizationAnalysisRunSourceData, GetOrganizationAnalysisRunSourceErrors, GetOrganizationAnalysisRunSourceResponses, GetOrganizationDiscoveryData, GetOrganizationDiscoveryErrors, GetOrganizationDiscoveryResponses, GetOrganizationFacilitationContentData, GetOrganizationFacilitationContentErrors, GetOrganizationFacilitationContentForEditData, GetOrganizationFacilitationContentForEditErrors, GetOrganizationFacilitationContentForEditResponses, GetOrganizationFacilitationContentResponses, GetOrganizationFacilitationFaqData, GetOrganizationFacilitationFaqErrors, GetOrganizationFacilitationFaqResponses, GetOrganizationFacilitationSupportData, GetOrganizationFacilitationSupportErrors, GetOrganizationFacilitationSupportResponses, GetOrganizationFacilitationWelcomeData, GetOrganizationFacilitationWelcomeErrors, GetOrganizationFacilitationWelcomeResponses, GetOrganizationResourceLibraryData, GetOrganizationResourceLibraryErrors, GetOrganizationResourceLibraryResponses, GetOrganizationResourceLinkData, GetOrganizationResourceLinkErrors, GetOrganizationResourceLinkResponses, GetPersonalTestData, GetPersonalTestErrors, GetPersonalTestResponses, GetProjectFacilitationSessionData, GetProjectFacilitationSessionErrors, GetProjectFacilitationSessionResponses, GetProviderTestRunData, GetProviderTestRunErrors, GetProviderTestRunResponses, GetRolloutFacilitationSettingsData, GetRolloutFacilitationSettingsErrors, GetRolloutFacilitationSettingsResponses, GetRolloutMovePlanData, GetRolloutMovePlanErrors, GetRolloutMovePlanResponses, GetRolloutStatusData, GetRolloutStatusErrors, GetRolloutStatusResponses, GetRunCanvasViewPreviewData, GetRunCanvasViewPreviewErrors, GetRunCanvasViewPreviewResponses, GetSessionFacilitationFaqData, GetSessionFacilitationFaqErrors, GetSessionFacilitationFaqResponses, GetSessionFacilitationStateData, GetSessionFacilitationStateErrors, GetSessionFacilitationStateResponses, GetSessionFacilitationStepsData, GetSessionFacilitationStepsErrors, GetSessionFacilitationStepsResponses, GetSessionFacilitationSupportData, GetSessionFacilitationSupportErrors, GetSessionFacilitationSupportResponses, GetSynthesisContentData, GetSynthesisContentErrors, GetSynthesisContentResponses, GetSynthesisData, GetSynthesisErrors, GetSynthesisInternalReportData, GetSynthesisInternalReportErrors, GetSynthesisInternalReportResponses, GetSynthesisPublicationData, GetSynthesisPublicationErrors, GetSynthesisPublicationResponses, GetSynthesisResponses, GetSynthesisVotesResultsData, GetSynthesisVotesResultsErrors, GetSynthesisVotesResultsResponses, GetSynthesisVotesSummaryData, GetSynthesisVotesSummaryErrors, GetSynthesisVotesSummaryResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, LinkCanvasRunData, LinkCanvasRunErrors, LinkCanvasRunResponses, ListAnalysisCodebookSourcesData, ListAnalysisCodebookSourcesErrors, ListAnalysisCodebookSourcesResponses, ListAnalysisRunArtifactsAdminData, ListAnalysisRunArtifactsAdminErrors, ListAnalysisRunArtifactsAdminResponses, ListCollectExportProjectsData, ListCollectExportProjectsErrors, ListCollectExportProjectsResponses, ListCollectLensesData, ListCollectLensesErrors, ListCollectLensesResponses, ListCollectProjectInterviewActivityLinksData, ListCollectProjectInterviewActivityLinksErrors, ListCollectProjectInterviewActivityLinksResponses, ListCollectProjectRecipientCodesData, ListCollectProjectRecipientCodesErrors, ListCollectProjectRecipientCodesResponses, ListCollectProjectRecipientMembersData, ListCollectProjectRecipientMembersErrors, ListCollectProjectRecipientMembersResponses, ListCollectProjectsData, ListCollectProjectsErrors, ListCollectProjectsResponses, ListDiscoveriesForOrgProjectData, ListDiscoveriesForOrgProjectErrors, ListDiscoveriesForOrgProjectResponses, ListFacilitationSessionPromptOptionsData, ListFacilitationSessionPromptOptionsErrors, ListFacilitationSessionPromptOptionsResponses, ListFacilitationTemplatesData, ListFacilitationTemplatesErrors, ListFacilitationTemplatesResponses, ListFacilitatorSessionsData, ListFacilitatorSessionsErrors, ListFacilitatorSessionsResponses, ListKitCategoriesData, ListKitCategoriesErrors, ListKitCategoriesResponses, ListKitOrgAccessData, ListKitOrgAccessErrors, ListKitOrgAccessResponses, ListKitPromptOptionsData, ListKitPromptOptionsErrors, ListKitPromptOptionsResponses, ListKitRolloutsData, ListKitRolloutsErrors, ListKitRolloutsResponses, ListKitsData, ListKitsErrors, ListKitsResponses, ListKitVersionsData, ListKitVersionsErrors, ListKitVersionsResponses, ListLensMergeCandidatesData, ListLensMergeCandidatesErrors, ListLensMergeCandidatesResponses, ListMyCollectInvitationsData, ListMyCollectInvitationsErrors, ListMyCollectInvitationsResponses, ListOrganizationAnalysisRunsData, ListOrganizationAnalysisRunsErrors, ListOrganizationAnalysisRunsResponses, ListOrganizationDiscoveriesData, ListOrganizationDiscoveriesErrors, ListOrganizationDiscoveriesResponses, ListOrganizationKitCategoriesData, ListOrganizationKitCategoriesErrors, ListOrganizationKitCategoriesResponses, ListOrganizationKitsData, ListOrganizationKitsErrors, ListOrganizationKitsResponses, ListOrganizationResourcesData, ListOrganizationResourcesErrors, ListOrganizationResourcesResponses, ListPipelineModelChainsData, ListPipelineModelChainsErrors, ListPipelineModelChainsResponses, ListPromptTemplateDetailsData, ListPromptTemplateDetailsErrors, ListPromptTemplateDetailsResponses, ListRolloutFacilitatorCandidatesData, ListRolloutFacilitatorCandidatesErrors, ListRolloutFacilitatorCandidatesResponses, ListRolloutsData, ListRolloutsErrors, ListRolloutsResponses, ListRunsForOrganizationProjectData, ListRunsForOrganizationProjectErrors, ListRunsForOrganizationProjectResponses, ListSelfServeKitsData, ListSelfServeKitsErrors, ListSelfServeKitsResponses, ListSessionResourcesData, ListSessionResourcesErrors, ListSessionResourcesResponses, ListSynthesesData, ListSynthesesErrors, ListSynthesesResponses, ListSynthesisRevisionsData, ListSynthesisRevisionsErrors, ListSynthesisRevisionsResponses, LookupCanvasesByExternalReferenceData, LookupCanvasesByExternalReferenceErrors, LookupCanvasesByExternalReferenceResponses, MarkSessionUnderstandingData, MarkSessionUnderstandingErrors, MarkSessionUnderstandingResponses, MoveRolloutData, MoveRolloutErrors, MoveRolloutResponses, PatchDiscoveryContextData, PatchDiscoveryContextErrors, PatchDiscoveryContextResponses, PostCanvasManagementReportPdfData, PostCanvasManagementReportPdfErrors, PostCanvasManagementReportPdfResponses, PostCanvasParticipationCompleteData, PostCanvasParticipationCompleteErrors, PostCanvasParticipationCompleteResponses, PostCanvasParticipationPingData, PostCanvasParticipationPingErrors, PostCanvasParticipationPingResponses, PostCanvasViewReportPdfData, PostCanvasViewReportPdfErrors, PostCanvasViewReportPdfResponses, PreviewCollectLensData, PreviewCollectLensDraftData, PreviewCollectLensDraftErrors, PreviewCollectLensDraftResponses, PreviewCollectLensErrors, PreviewCollectLensResponses, ProposeLensMergePlanData, ProposeLensMergePlanErrors, ProposeLensMergePlanResponses, PublishCollectProjectData, PublishCollectProjectErrors, PublishCollectProjectResponses, PublishKitDraftData, PublishKitDraftErrors, PublishKitDraftResponses, PublishRunSynthesisData, PublishRunSynthesisErrors, PublishRunSynthesisResponses, PutCanvasParticipationVotesData, PutCanvasParticipationVotesErrors, PutCanvasParticipationVotesResponses, ReassignAnalysisRunsByOrganizationProjectData, ReassignAnalysisRunsByOrganizationProjectErrors, ReassignAnalysisRunsByOrganizationProjectResponses, ReassignCollectProjectData, ReassignCollectProjectErrors, ReassignCollectProjectResponses, ReassignCollectProjectsByOrganizationProjectData, ReassignCollectProjectsByOrganizationProjectErrors, ReassignCollectProjectsByOrganizationProjectResponses, ReassignSynthesesByOrganizationProjectData, ReassignSynthesesByOrganizationProjectErrors, ReassignSynthesesByOrganizationProjectResponses, ReassignSynthesisProjectData, ReassignSynthesisProjectErrors, ReassignSynthesisProjectResponses, RefineLensMergePlanData, RefineLensMergePlanErrors, RefineLensMergePlanResponses, RemindCollectProjectRecipientsData, RemindCollectProjectRecipientsErrors, RemindCollectProjectRecipientsResponses, RemoveCollectProjectLanguageData, RemoveCollectProjectLanguageErrors, RemoveCollectProjectLanguageResponses, RemovePersonalTestData, RemovePersonalTestErrors, RemovePersonalTestResponses, RemoveRolloutFacilitatorData, RemoveRolloutFacilitatorErrors, RemoveRolloutFacilitatorResponses, RemoveSynthesisLanguageData, RemoveSynthesisLanguageErrors, RemoveSynthesisLanguageResponses, ReopenCollectProjectData, ReopenCollectProjectErrors, ReopenCollectProjectResponses, ReopenSynthesisVotingData, ReopenSynthesisVotingErrors, ReopenSynthesisVotingResponses, ReorderOrganizationResourcesData, ReorderOrganizationResourcesErrors, ReorderOrganizationResourcesResponses, ReplaceKitOrgAccessData, ReplaceKitOrgAccessErrors, ReplaceKitOrgAccessResponses, ReplaceSynthesisContentData, ReplaceSynthesisContentErrors, ReplaceSynthesisContentResponses, ResendCollectProjectRecipientInvitationData, ResendCollectProjectRecipientInvitationErrors, ResendCollectProjectRecipientInvitationResponses, ResetPersonalTestData, ResetPersonalTestErrors, ResetPersonalTestResponses, ResetSessionUnderstandingData, ResetSessionUnderstandingErrors, ResetSessionUnderstandingResponses, ResolveCollectLensDraftCatalogData, ResolveCollectLensDraftCatalogErrors, ResolveCollectLensDraftCatalogResponses, RestoreCollectExportConversationsData, RestoreCollectExportConversationsErrors, RestoreCollectExportConversationsResponses, RestoreSynthesisRevisionData, RestoreSynthesisRevisionErrors, RestoreSynthesisRevisionResponses, RevokeCollectProjectInterviewActivityLinkData, RevokeCollectProjectInterviewActivityLinkErrors, RevokeCollectProjectInterviewActivityLinkResponses, RevokeCollectProjectRecipientCodeData, RevokeCollectProjectRecipientCodeErrors, RevokeCollectProjectRecipientCodeResponses, RotateSynthesisExternalIdData, RotateSynthesisExternalIdErrors, RotateSynthesisExternalIdResponses, SaveFacilitationSessionContentData, SaveFacilitationSessionContentErrors, SaveFacilitationSessionContentResponses, SaveFacilitationSessionWorksheetData, SaveFacilitationSessionWorksheetErrors, SaveFacilitationSessionWorksheetResponses, SaveKitDraftData, SaveKitDraftErrors, SaveKitDraftResponses, SaveOrganizationFacilitationContentData, SaveOrganizationFacilitationContentErrors, SaveOrganizationFacilitationContentResponses, SendCollectProjectRecipientInvitationsData, SendCollectProjectRecipientInvitationsErrors, SendCollectProjectRecipientInvitationsResponses, SetCollectProjectDraftData, SetCollectProjectDraftErrors, SetCollectProjectDraftResponses, SetFacilitationSessionResultsSourceData, SetFacilitationSessionResultsSourceErrors, SetFacilitationSessionResultsSourceResponses, SetSessionFacilitationCompletionData, SetSessionFacilitationCompletionErrors, SetSessionFacilitationCompletionResponses, SkipCollectConversationQuestionData, SkipCollectConversationQuestionErrors, SkipCollectConversationQuestionResponses, StartAnalysisRunFromCollectProjectData, StartAnalysisRunFromCollectProjectErrors, StartAnalysisRunFromCollectProjectResponses, StartAnalysisRunFromLensData, StartAnalysisRunFromLensErrors, StartAnalysisRunFromLensResponses, StartCollectConversationData, StartCollectConversationErrors, StartCollectConversationResponses, StartCompactFromScenarioData, StartCompactFromScenarioErrors, StartCompactFromScenarioResponses, StartFacilitationSessionVoteRoundData, StartFacilitationSessionVoteRoundErrors, StartFacilitationSessionVoteRoundResponses, StartSelfServeSessionData, StartSelfServeSessionErrors, StartSelfServeSessionResponses, SuggestLensMergeSourceLabelsData, SuggestLensMergeSourceLabelsErrors, SuggestLensMergeSourceLabelsResponses, SyntheticResponsesGeneratePersonasData, SyntheticResponsesGeneratePersonasErrors, SyntheticResponsesGeneratePersonasResponses, SyntheticResponsesGetContextData, SyntheticResponsesGetContextErrors, SyntheticResponsesGetContextResponses, SyntheticResponsesRunData, SyntheticResponsesRunErrors, SyntheticResponsesRunResponses, UnassignDiscoveryMemberData, UnassignDiscoveryMemberErrors, UnassignDiscoveryMemberResponses, UndoCollectConversationLastMessageData, UndoCollectConversationLastMessageErrors, UndoCollectConversationLastMessageResponses, UpdateAnalysisRunTitleData, UpdateAnalysisRunTitleErrors, UpdateAnalysisRunTitleResponses, UpdateCollectLensData, UpdateCollectLensErrors, UpdateCollectLensResponses, UpdateCollectProjectData, UpdateCollectProjectErrors, UpdateCollectProjectExternalIdData, UpdateCollectProjectExternalIdErrors, UpdateCollectProjectExternalIdResponses, UpdateCollectProjectInterviewActivityLinkData, UpdateCollectProjectInterviewActivityLinkErrors, UpdateCollectProjectInterviewActivityLinkResponses, UpdateCollectProjectIntroData, UpdateCollectProjectIntroErrors, UpdateCollectProjectIntroResponses, UpdateCollectProjectResponses, UpdateCollectProjectTemplateData, UpdateCollectProjectTemplateErrors, UpdateCollectProjectTemplateMessagesData, UpdateCollectProjectTemplateMessagesErrors, UpdateCollectProjectTemplateMessagesResponses, UpdateCollectProjectTemplateResponses, UpdateDiscoveryData, UpdateDiscoveryErrors, UpdateDiscoveryResponses, UpdateKitCategoryData, UpdateKitCategoryErrors, UpdateKitCategoryResponses, UpdateKitData, UpdateKitErrors, UpdateKitResponses, UpdateOrganizationResourceData, UpdateOrganizationResourceErrors, UpdateOrganizationResourceFolderData, UpdateOrganizationResourceFolderErrors, UpdateOrganizationResourceFolderResponses, UpdateOrganizationResourceResponses, UpdateProviderTestRunStateData, UpdateProviderTestRunStateErrors, UpdateProviderTestRunStateResponses, UpdateRolloutData, UpdateRolloutErrors, UpdateRolloutFacilitationSettingsData, UpdateRolloutFacilitationSettingsErrors, UpdateRolloutFacilitationSettingsResponses, UpdateRolloutResponses, UpdateSynthesisMetadataData, UpdateSynthesisMetadataErrors, UpdateSynthesisMetadataResponses, UpdateSynthesisPublicationData, UpdateSynthesisPublicationErrors, UpdateSynthesisPublicationResponses, UploadCollectProjectImageData, UploadCollectProjectImageErrors, UploadCollectProjectImageResponses, UploadFacilitationSessionImageData, UploadFacilitationSessionImageErrors, UploadFacilitationSessionImageResponses, UploadKitImageData, UploadKitImageErrors, UploadKitImageResponses, UploadOrganizationResourceFileData, UploadOrganizationResourceFileErrors, UploadOrganizationResourceFileResponses, ValidateLoadTestCompactCorpusData, ValidateLoadTestCompactCorpusErrors, ValidateLoadTestCompactCorpusResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Start Compact From Scenario
 */
export const startCompactFromScenario = <ThrowOnError extends boolean = false>(options: Options<StartCompactFromScenarioData, ThrowOnError>): RequestResult<StartCompactFromScenarioResponses, StartCompactFromScenarioErrors, ThrowOnError> => (options.client ?? client).post<StartCompactFromScenarioResponses, StartCompactFromScenarioErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/app/runs/start-compact-from-scenario/{organization_project_id}/{collect_project_id}/',
    ...options
});

/**
 * Delete all analysis runs by organization project ID
 */
export const cleanupAnalysisRunsByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CleanupAnalysisRunsByOrganizationProjectData, ThrowOnError>): RequestResult<CleanupAnalysisRunsByOrganizationProjectResponses, CleanupAnalysisRunsByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).delete<CleanupAnalysisRunsByOrganizationProjectResponses, CleanupAnalysisRunsByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/cleanup/by-organization-project/{organization_project_id}/',
    ...options
});

/**
 * Count analysis runs by organization project ID
 */
export const countAnalysisRunsByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CountAnalysisRunsByOrganizationProjectData, ThrowOnError>): RequestResult<CountAnalysisRunsByOrganizationProjectResponses, CountAnalysisRunsByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).get<CountAnalysisRunsByOrganizationProjectResponses, CountAnalysisRunsByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/cleanup/by-organization-project/{organization_project_id}/counts/',
    ...options
});

/**
 * Get Analysis Codebook Library
 */
export const getAnalysisCodebookLibrary = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisCodebookLibraryData, ThrowOnError>): RequestResult<GetAnalysisCodebookLibraryResponses, GetAnalysisCodebookLibraryErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisCodebookLibraryResponses, GetAnalysisCodebookLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/codebooks/library/',
    ...options
});

/**
 * List Runs For Organization Project
 */
export const listRunsForOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<ListRunsForOrganizationProjectData, ThrowOnError>): RequestResult<ListRunsForOrganizationProjectResponses, ListRunsForOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).get<ListRunsForOrganizationProjectResponses, ListRunsForOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/organization-projects/{organization_project_id}/runs/',
    ...options
});

/**
 * Link Canvas Run
 */
export const linkCanvasRun = <ThrowOnError extends boolean = false>(options: Options<LinkCanvasRunData, ThrowOnError>): RequestResult<LinkCanvasRunResponses, LinkCanvasRunErrors, ThrowOnError> => (options.client ?? client).post<LinkCanvasRunResponses, LinkCanvasRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/organization-projects/{organization_project_id}/runs/link-canvas/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Run Canvas View Preview
 */
export const getRunCanvasViewPreview = <ThrowOnError extends boolean = false>(options: Options<GetRunCanvasViewPreviewData, ThrowOnError>): RequestResult<GetRunCanvasViewPreviewResponses, GetRunCanvasViewPreviewErrors, ThrowOnError> => (options.client ?? client).get<GetRunCanvasViewPreviewResponses, GetRunCanvasViewPreviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/organization-projects/{organization_project_id}/runs/{run_id}/canvas-view-preview/',
    ...options
});

/**
 * Publish Run Synthesis
 */
export const publishRunSynthesis = <ThrowOnError extends boolean = false>(options: Options<PublishRunSynthesisData, ThrowOnError>): RequestResult<PublishRunSynthesisResponses, PublishRunSynthesisErrors, ThrowOnError> => (options.client ?? client).post<PublishRunSynthesisResponses, PublishRunSynthesisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/organization-projects/{organization_project_id}/runs/{run_id}/publish-synthesis/',
    ...options
});

/**
 * List Analysis Codebook Sources
 */
export const listAnalysisCodebookSources = <ThrowOnError extends boolean = false>(options: Options<ListAnalysisCodebookSourcesData, ThrowOnError>): RequestResult<ListAnalysisCodebookSourcesResponses, ListAnalysisCodebookSourcesErrors, ThrowOnError> => (options.client ?? client).get<ListAnalysisCodebookSourcesResponses, ListAnalysisCodebookSourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/codebook-sources/',
    ...options
});

/**
 * List Pipeline Model Chains
 */
export const listPipelineModelChains = <ThrowOnError extends boolean = false>(options: Options<ListPipelineModelChainsData, ThrowOnError>): RequestResult<ListPipelineModelChainsResponses, ListPipelineModelChainsErrors, ThrowOnError> => (options.client ?? client).get<ListPipelineModelChainsResponses, ListPipelineModelChainsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/pipeline-model-chains/',
    ...options
});

/**
 * List Prompt Template Details
 */
export const listPromptTemplateDetails = <ThrowOnError extends boolean = false>(options: Options<ListPromptTemplateDetailsData, ThrowOnError>): RequestResult<ListPromptTemplateDetailsResponses, ListPromptTemplateDetailsErrors, ThrowOnError> => (options.client ?? client).get<ListPromptTemplateDetailsResponses, ListPromptTemplateDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/prompt-template-details/',
    ...options
});

/**
 * Reassign Analysis Runs By Organization Project
 */
export const reassignAnalysisRunsByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<ReassignAnalysisRunsByOrganizationProjectData, ThrowOnError>): RequestResult<ReassignAnalysisRunsByOrganizationProjectResponses, ReassignAnalysisRunsByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).post<ReassignAnalysisRunsByOrganizationProjectResponses, ReassignAnalysisRunsByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/reassign-organization/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Analysis Run From Collect Project
 */
export const startAnalysisRunFromCollectProject = <ThrowOnError extends boolean = false>(options: Options<StartAnalysisRunFromCollectProjectData, ThrowOnError>): RequestResult<StartAnalysisRunFromCollectProjectResponses, StartAnalysisRunFromCollectProjectErrors, ThrowOnError> => (options.client ?? client).post<StartAnalysisRunFromCollectProjectResponses, StartAnalysisRunFromCollectProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/start-from-collect-project/{organization_project_id}/{collect_project_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Analysis Run From Lens
 */
export const startAnalysisRunFromLens = <ThrowOnError extends boolean = false>(options: Options<StartAnalysisRunFromLensData, ThrowOnError>): RequestResult<StartAnalysisRunFromLensResponses, StartAnalysisRunFromLensErrors, ThrowOnError> => (options.client ?? client).post<StartAnalysisRunFromLensResponses, StartAnalysisRunFromLensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/start-from-lens/{organization_project_id}/{lens_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Analysis Run
 */
export const deleteAnalysisRun = <ThrowOnError extends boolean = false>(options: Options<DeleteAnalysisRunData, ThrowOnError>): RequestResult<DeleteAnalysisRunResponses, DeleteAnalysisRunErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAnalysisRunResponses, DeleteAnalysisRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/',
    ...options
});

/**
 * Get Analysis Run
 */
export const getAnalysisRun = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisRunData, ThrowOnError>): RequestResult<GetAnalysisRunResponses, GetAnalysisRunErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisRunResponses, GetAnalysisRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/',
    ...options
});

/**
 * Get Analysis Job Admin
 */
export const getAnalysisJobAdmin = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisJobAdminData, ThrowOnError>): RequestResult<GetAnalysisJobAdminResponses, GetAnalysisJobAdminErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisJobAdminResponses, GetAnalysisJobAdminErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/admin/',
    ...options
});

/**
 * List Analysis Run Artifacts Admin
 */
export const listAnalysisRunArtifactsAdmin = <ThrowOnError extends boolean = false>(options: Options<ListAnalysisRunArtifactsAdminData, ThrowOnError>): RequestResult<ListAnalysisRunArtifactsAdminResponses, ListAnalysisRunArtifactsAdminErrors, ThrowOnError> => (options.client ?? client).get<ListAnalysisRunArtifactsAdminResponses, ListAnalysisRunArtifactsAdminErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/admin/artifacts/',
    ...options
});

/**
 * Get Analysis Run Artifact Admin
 */
export const getAnalysisRunArtifactAdmin = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisRunArtifactAdminData, ThrowOnError>): RequestResult<GetAnalysisRunArtifactAdminResponses, GetAnalysisRunArtifactAdminErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisRunArtifactAdminResponses, GetAnalysisRunArtifactAdminErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/admin/artifacts/{artifact_key}/',
    ...options
});

/**
 * Download Analysis Run Artifact Admin
 */
export const downloadAnalysisRunArtifactAdmin = <ThrowOnError extends boolean = false>(options: Options<DownloadAnalysisRunArtifactAdminData, ThrowOnError>): RequestResult<DownloadAnalysisRunArtifactAdminResponses, DownloadAnalysisRunArtifactAdminErrors, ThrowOnError> => (options.client ?? client).get<DownloadAnalysisRunArtifactAdminResponses, DownloadAnalysisRunArtifactAdminErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/admin/artifacts/{artifact_key}/download/',
    ...options
});

/**
 * Get Analysis Run Overview Admin
 */
export const getAnalysisRunOverviewAdmin = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisRunOverviewAdminData, ThrowOnError>): RequestResult<GetAnalysisRunOverviewAdminResponses, GetAnalysisRunOverviewAdminErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisRunOverviewAdminResponses, GetAnalysisRunOverviewAdminErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/admin/overview/',
    ...options
});

/**
 * Archive Analysis Run
 */
export const archiveAnalysisRun = <ThrowOnError extends boolean = false>(options: Options<ArchiveAnalysisRunData, ThrowOnError>): RequestResult<ArchiveAnalysisRunResponses, ArchiveAnalysisRunErrors, ThrowOnError> => (options.client ?? client).post<ArchiveAnalysisRunResponses, ArchiveAnalysisRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/archive/',
    ...options
});

/**
 * Cancel Analysis Run
 */
export const cancelAnalysisRun = <ThrowOnError extends boolean = false>(options: Options<CancelAnalysisRunData, ThrowOnError>): RequestResult<CancelAnalysisRunResponses, CancelAnalysisRunErrors, ThrowOnError> => (options.client ?? client).post<CancelAnalysisRunResponses, CancelAnalysisRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/cancel/',
    ...options
});

/**
 * Get Analysis Run Codebook
 */
export const getAnalysisRunCodebook = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisRunCodebookData, ThrowOnError>): RequestResult<GetAnalysisRunCodebookResponses, GetAnalysisRunCodebookErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisRunCodebookResponses, GetAnalysisRunCodebookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/codebook/',
    ...options
});

/**
 * Update Analysis Run Title
 */
export const updateAnalysisRunTitle = <ThrowOnError extends boolean = false>(options: Options<UpdateAnalysisRunTitleData, ThrowOnError>): RequestResult<UpdateAnalysisRunTitleResponses, UpdateAnalysisRunTitleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAnalysisRunTitleResponses, UpdateAnalysisRunTitleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/analysis/management/runs/{run_id}/title/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lookup Canvases By External Reference
 */
export const lookupCanvasesByExternalReference = <ThrowOnError extends boolean = false>(options: Options<LookupCanvasesByExternalReferenceData, ThrowOnError>): RequestResult<LookupCanvasesByExternalReferenceResponses, LookupCanvasesByExternalReferenceErrors, ThrowOnError> => (options.client ?? client).get<LookupCanvasesByExternalReferenceResponses, LookupCanvasesByExternalReferenceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/management/lookup-by-external-reference/',
    ...options
});

/**
 * Get a canvas by its integer ID
 */
export const getCanvasById = <ThrowOnError extends boolean = false>(options: Options<GetCanvasByIdData, ThrowOnError>): RequestResult<GetCanvasByIdResponses, GetCanvasByIdErrors, ThrowOnError> => (options.client ?? client).get<GetCanvasByIdResponses, GetCanvasByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/management/{canvas_id}/',
    ...options
});

/**
 * Get participation metrics for a canvas
 */
export const getCanvasParticipation = <ThrowOnError extends boolean = false>(options: Options<GetCanvasParticipationData, ThrowOnError>): RequestResult<GetCanvasParticipationResponses, GetCanvasParticipationErrors, ThrowOnError> => (options.client ?? client).get<GetCanvasParticipationResponses, GetCanvasParticipationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/management/{canvas_id}/participation/',
    ...options
});

/**
 * Post Canvas Management Report Pdf
 */
export const postCanvasManagementReportPdf = <ThrowOnError extends boolean = false>(options: Options<PostCanvasManagementReportPdfData, ThrowOnError>): RequestResult<PostCanvasManagementReportPdfResponses, PostCanvasManagementReportPdfErrors, ThrowOnError> => (options.client ?? client).post<PostCanvasManagementReportPdfResponses, PostCanvasManagementReportPdfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/management/{canvas_id}/report-pdf/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get vote results for a canvas
 */
export const getCanvasVotesResults = <ThrowOnError extends boolean = false>(options: Options<GetCanvasVotesResultsData, ThrowOnError>): RequestResult<GetCanvasVotesResultsResponses, GetCanvasVotesResultsErrors, ThrowOnError> => (options.client ?? client).get<GetCanvasVotesResultsResponses, GetCanvasVotesResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/management/{canvas_id}/votes/results/',
    ...options
});

/**
 * Get Canvas Participation View
 */
export const getCanvasParticipationView = <ThrowOnError extends boolean = false>(options: Options<GetCanvasParticipationViewData, ThrowOnError>): RequestResult<GetCanvasParticipationViewResponses, GetCanvasParticipationViewErrors, ThrowOnError> => (options.client ?? client).get<GetCanvasParticipationViewResponses, GetCanvasParticipationViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/participation/{token}/',
    ...options
});

/**
 * Post Canvas Participation Complete
 */
export const postCanvasParticipationComplete = <ThrowOnError extends boolean = false>(options: Options<PostCanvasParticipationCompleteData, ThrowOnError>): RequestResult<PostCanvasParticipationCompleteResponses, PostCanvasParticipationCompleteErrors, ThrowOnError> => (options.client ?? client).post<PostCanvasParticipationCompleteResponses, PostCanvasParticipationCompleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/participation/{token}/complete/',
    ...options
});

/**
 * Post Canvas Participation Ping
 */
export const postCanvasParticipationPing = <ThrowOnError extends boolean = false>(options: Options<PostCanvasParticipationPingData, ThrowOnError>): RequestResult<PostCanvasParticipationPingResponses, PostCanvasParticipationPingErrors, ThrowOnError> => (options.client ?? client).post<PostCanvasParticipationPingResponses, PostCanvasParticipationPingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/participation/{token}/ping/',
    ...options
});

/**
 * Get Canvas Participation Results
 */
export const getCanvasParticipationResults = <ThrowOnError extends boolean = false>(options: Options<GetCanvasParticipationResultsData, ThrowOnError>): RequestResult<GetCanvasParticipationResultsResponses, GetCanvasParticipationResultsErrors, ThrowOnError> => (options.client ?? client).get<GetCanvasParticipationResultsResponses, GetCanvasParticipationResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/participation/{token}/results/',
    ...options
});

/**
 * Put Canvas Participation Votes
 */
export const putCanvasParticipationVotes = <ThrowOnError extends boolean = false>(options: Options<PutCanvasParticipationVotesData, ThrowOnError>): RequestResult<PutCanvasParticipationVotesResponses, PutCanvasParticipationVotesErrors, ThrowOnError> => (options.client ?? client).put<PutCanvasParticipationVotesResponses, PutCanvasParticipationVotesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/participation/{token}/votes/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Canvas Participation Votes
 */
export const getMyCanvasParticipationVotes = <ThrowOnError extends boolean = false>(options: Options<GetMyCanvasParticipationVotesData, ThrowOnError>): RequestResult<GetMyCanvasParticipationVotesResponses, GetMyCanvasParticipationVotesErrors, ThrowOnError> => (options.client ?? client).get<GetMyCanvasParticipationVotesResponses, GetMyCanvasParticipationVotesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/participation/{token}/votes/me/',
    ...options
});

/**
 * Get Canvas View
 */
export const getCanvasView = <ThrowOnError extends boolean = false>(options: Options<GetCanvasViewData, ThrowOnError>): RequestResult<GetCanvasViewResponses, GetCanvasViewErrors, ThrowOnError> => (options.client ?? client).get<GetCanvasViewResponses, GetCanvasViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/view/{external_id}/',
    ...options
});

/**
 * Get Canvas View Insights
 */
export const getCanvasViewInsights = <ThrowOnError extends boolean = false>(options: Options<GetCanvasViewInsightsData, ThrowOnError>): RequestResult<GetCanvasViewInsightsResponses, GetCanvasViewInsightsErrors, ThrowOnError> => (options.client ?? client).get<GetCanvasViewInsightsResponses, GetCanvasViewInsightsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/canvas/view/{external_id}/insights/',
    ...options
});

/**
 * Post Canvas View Report Pdf
 */
export const postCanvasViewReportPdf = <ThrowOnError extends boolean = false>(options: Options<PostCanvasViewReportPdfData, ThrowOnError>): RequestResult<PostCanvasViewReportPdfResponses, PostCanvasViewReportPdfErrors, ThrowOnError> => (options.client ?? client).post<PostCanvasViewReportPdfResponses, PostCanvasViewReportPdfErrors, ThrowOnError>({
    url: '/canvas/view/{external_id}/report-pdf/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Canvas View Report
 */
export const getCanvasViewReport = <ThrowOnError extends boolean = false>(options: Options<GetCanvasViewReportData, ThrowOnError>): RequestResult<GetCanvasViewReportResponses, GetCanvasViewReportErrors, ThrowOnError> => (options.client ?? client).get<GetCanvasViewReportResponses, GetCanvasViewReportErrors, ThrowOnError>({ url: '/canvas/view/{external_id}/report/', ...options });

/**
 * Delete all projects by organization project ID
 *
 * Delete all collect projects under an organization project.
 * Internal endpoint for administrative cleanup.
 */
export const cleanupCollectProjectsByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CleanupCollectProjectsByOrganizationProjectData, ThrowOnError>): RequestResult<CleanupCollectProjectsByOrganizationProjectResponses, CleanupCollectProjectsByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).delete<CleanupCollectProjectsByOrganizationProjectResponses, CleanupCollectProjectsByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/cleanup/by-organization-project/{organization_project_id}/',
    ...options
});

/**
 * Count collect resources by organization project ID
 */
export const countCollectProjectsByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CountCollectProjectsByOrganizationProjectData, ThrowOnError>): RequestResult<CountCollectProjectsByOrganizationProjectResponses, CountCollectProjectsByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).get<CountCollectProjectsByOrganizationProjectResponses, CountCollectProjectsByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/cleanup/by-organization-project/{organization_project_id}/counts/',
    ...options
});

/**
 * Start Conversation
 */
export const startCollectConversation = <ThrowOnError extends boolean = false>(options: Options<StartCollectConversationData, ThrowOnError>): RequestResult<StartCollectConversationResponses, StartCollectConversationErrors, ThrowOnError> => (options.client ?? client).post<StartCollectConversationResponses, StartCollectConversationErrors, ThrowOnError>({
    url: '/collect/conversations/start/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Conversation
 */
export const getCollectConversation = <ThrowOnError extends boolean = false>(options: Options<GetCollectConversationData, ThrowOnError>): RequestResult<GetCollectConversationResponses, GetCollectConversationErrors, ThrowOnError> => (options.client ?? client).get<GetCollectConversationResponses, GetCollectConversationErrors, ThrowOnError>({ url: '/collect/conversations/{conversation_id}/', ...options });

/**
 * Label Answer
 */
export const answerCollectConversationLabel = <ThrowOnError extends boolean = false>(options: Options<AnswerCollectConversationLabelData, ThrowOnError>): RequestResult<AnswerCollectConversationLabelResponses, AnswerCollectConversationLabelErrors, ThrowOnError> => (options.client ?? client).post<AnswerCollectConversationLabelResponses, AnswerCollectConversationLabelErrors, ThrowOnError>({
    url: '/collect/conversations/{conversation_id}/answer/label/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip Question
 */
export const skipCollectConversationQuestion = <ThrowOnError extends boolean = false>(options: Options<SkipCollectConversationQuestionData, ThrowOnError>): RequestResult<SkipCollectConversationQuestionResponses, SkipCollectConversationQuestionErrors, ThrowOnError> => (options.client ?? client).post<SkipCollectConversationQuestionResponses, SkipCollectConversationQuestionErrors, ThrowOnError>({
    url: '/collect/conversations/{conversation_id}/answer/skip/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Text Answer
 */
export const answerCollectConversationText = <ThrowOnError extends boolean = false>(options: Options<AnswerCollectConversationTextData, ThrowOnError>): RequestResult<AnswerCollectConversationTextResponses, AnswerCollectConversationTextErrors, ThrowOnError> => (options.client ?? client).post<AnswerCollectConversationTextResponses, AnswerCollectConversationTextErrors, ThrowOnError>({
    url: '/collect/conversations/{conversation_id}/answer/text/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Edit Text Answer
 */
export const editCollectConversationTextAnswer = <ThrowOnError extends boolean = false>(options: Options<EditCollectConversationTextAnswerData, ThrowOnError>): RequestResult<EditCollectConversationTextAnswerResponses, EditCollectConversationTextAnswerErrors, ThrowOnError> => (options.client ?? client).post<EditCollectConversationTextAnswerResponses, EditCollectConversationTextAnswerErrors, ThrowOnError>({
    url: '/collect/conversations/{conversation_id}/answer/text/edit/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Undo
 */
export const undoCollectConversationLastMessage = <ThrowOnError extends boolean = false>(options: Options<UndoCollectConversationLastMessageData, ThrowOnError>): RequestResult<UndoCollectConversationLastMessageResponses, UndoCollectConversationLastMessageErrors, ThrowOnError> => (options.client ?? client).post<UndoCollectConversationLastMessageResponses, UndoCollectConversationLastMessageErrors, ThrowOnError>({ url: '/collect/conversations/{conversation_id}/undo/', ...options });

/**
 * Export Conversations
 *
 * Export conversations as CSV.
 */
export const exportCollectConversations = <ThrowOnError extends boolean = false>(options: Options<ExportCollectConversationsData, ThrowOnError>): RequestResult<ExportCollectConversationsResponses, ExportCollectConversationsErrors, ThrowOnError> => (options.client ?? client).post<ExportCollectConversationsResponses, ExportCollectConversationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/data-export-api/export/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Projects
 *
 * List all projects and their conversation statistics.
 */
export const listCollectExportProjects = <ThrowOnError extends boolean = false>(options: Options<ListCollectExportProjectsData, ThrowOnError>): RequestResult<ListCollectExportProjectsResponses, ListCollectExportProjectsErrors, ThrowOnError> => (options.client ?? client).get<ListCollectExportProjectsResponses, ListCollectExportProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/data-export-api/projects/',
    ...options
});

/**
 * Delete Project Conversations
 *
 * Soft delete conversations by marking them as deleted.
 *
 * This endpoint accepts a list of up to 20 conversation IDs to delete.
 */
export const deleteCollectExportConversations = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectExportConversationsData, ThrowOnError>): RequestResult<DeleteCollectExportConversationsResponses, DeleteCollectExportConversationsErrors, ThrowOnError> => (options.client ?? client).post<DeleteCollectExportConversationsResponses, DeleteCollectExportConversationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/data-export-api/projects/{project_id}/conversations/delete/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore Project Conversations
 *
 * Restore soft-deleted conversations by marking them as not deleted.
 *
 * This endpoint can either:
 * 1. Restore specific conversations by providing a list of conversation IDs (up to 100)
 * 2. Restore all deleted conversations in a project by setting restore_all=True
 */
export const restoreCollectExportConversations = <ThrowOnError extends boolean = false>(options: Options<RestoreCollectExportConversationsData, ThrowOnError>): RequestResult<RestoreCollectExportConversationsResponses, RestoreCollectExportConversationsErrors, ThrowOnError> => (options.client ?? client).post<RestoreCollectExportConversationsResponses, RestoreCollectExportConversationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/data-export-api/projects/{project_id}/conversations/restore/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Conversation Summaries
 *
 * Get text summaries of conversations with pagination.
 */
export const getCollectExportConversationSummaries = <ThrowOnError extends boolean = false>(options: Options<GetCollectExportConversationSummariesData, ThrowOnError>): RequestResult<GetCollectExportConversationSummariesResponses, GetCollectExportConversationSummariesErrors, ThrowOnError> => (options.client ?? client).post<GetCollectExportConversationSummariesResponses, GetCollectExportConversationSummariesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/data-export-api/projects/{project_id}/conversations/summaries/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Statistics For Project
 *
 * Get statistics for categorical questions in a project.
 */
export const getCollectExportProjectStatistics = <ThrowOnError extends boolean = false>(options: Options<GetCollectExportProjectStatisticsData, ThrowOnError>): RequestResult<GetCollectExportProjectStatisticsResponses, GetCollectExportProjectStatisticsErrors, ThrowOnError> => (options.client ?? client).post<GetCollectExportProjectStatisticsResponses, GetCollectExportProjectStatisticsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/data-export-api/projects/{project_id}/statistics/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Lenses
 */
export const listCollectLenses = <ThrowOnError extends boolean = false>(options: Options<ListCollectLensesData, ThrowOnError>): RequestResult<ListCollectLensesResponses, ListCollectLensesErrors, ThrowOnError> => (options.client ?? client).get<ListCollectLensesResponses, ListCollectLensesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses',
    ...options
});

/**
 * Create Lens
 */
export const createCollectLens = <ThrowOnError extends boolean = false>(options: Options<CreateCollectLensData, ThrowOnError>): RequestResult<CreateCollectLensResponses, CreateCollectLensErrors, ThrowOnError> => (options.client ?? client).post<CreateCollectLensResponses, CreateCollectLensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Draft Catalog
 */
export const resolveCollectLensDraftCatalog = <ThrowOnError extends boolean = false>(options: Options<ResolveCollectLensDraftCatalogData, ThrowOnError>): RequestResult<ResolveCollectLensDraftCatalogResponses, ResolveCollectLensDraftCatalogErrors, ThrowOnError> => (options.client ?? client).post<ResolveCollectLensDraftCatalogResponses, ResolveCollectLensDraftCatalogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/draft/catalog',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Draft Preview
 */
export const previewCollectLensDraft = <ThrowOnError extends boolean = false>(options: Options<PreviewCollectLensDraftData, ThrowOnError>): RequestResult<PreviewCollectLensDraftResponses, PreviewCollectLensDraftErrors, ThrowOnError> => (options.client ?? client).post<PreviewCollectLensDraftResponses, PreviewCollectLensDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/draft/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Merge Candidates
 */
export const listLensMergeCandidates = <ThrowOnError extends boolean = false>(options: Options<ListLensMergeCandidatesData, ThrowOnError>): RequestResult<ListLensMergeCandidatesResponses, ListLensMergeCandidatesErrors, ThrowOnError> => (options.client ?? client).get<ListLensMergeCandidatesResponses, ListLensMergeCandidatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/merge-candidates',
    ...options
});

/**
 * Propose Merge Plan
 */
export const proposeLensMergePlan = <ThrowOnError extends boolean = false>(options: Options<ProposeLensMergePlanData, ThrowOnError>): RequestResult<ProposeLensMergePlanResponses, ProposeLensMergePlanErrors, ThrowOnError> => (options.client ?? client).post<ProposeLensMergePlanResponses, ProposeLensMergePlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/merge/propose-plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refine Merge Plan
 */
export const refineLensMergePlan = <ThrowOnError extends boolean = false>(options: Options<RefineLensMergePlanData, ThrowOnError>): RequestResult<RefineLensMergePlanResponses, RefineLensMergePlanErrors, ThrowOnError> => (options.client ?? client).post<RefineLensMergePlanResponses, RefineLensMergePlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/merge/refine-plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Suggest Merge Source Labels
 */
export const suggestLensMergeSourceLabels = <ThrowOnError extends boolean = false>(options: Options<SuggestLensMergeSourceLabelsData, ThrowOnError>): RequestResult<SuggestLensMergeSourceLabelsResponses, SuggestLensMergeSourceLabelsErrors, ThrowOnError> => (options.client ?? client).post<SuggestLensMergeSourceLabelsResponses, SuggestLensMergeSourceLabelsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/merge/suggest-source-labels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Lens
 */
export const deleteCollectLens = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectLensData, ThrowOnError>): RequestResult<DeleteCollectLensResponses, DeleteCollectLensErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCollectLensResponses, DeleteCollectLensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/{lens_id}',
    ...options
});

/**
 * Get Lens
 */
export const getCollectLens = <ThrowOnError extends boolean = false>(options: Options<GetCollectLensData, ThrowOnError>): RequestResult<GetCollectLensResponses, GetCollectLensErrors, ThrowOnError> => (options.client ?? client).get<GetCollectLensResponses, GetCollectLensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/{lens_id}',
    ...options
});

/**
 * Update Lens
 */
export const updateCollectLens = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectLensData, ThrowOnError>): RequestResult<UpdateCollectLensResponses, UpdateCollectLensErrors, ThrowOnError> => (options.client ?? client).patch<UpdateCollectLensResponses, UpdateCollectLensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/{lens_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive Lens
 */
export const archiveCollectLens = <ThrowOnError extends boolean = false>(options: Options<ArchiveCollectLensData, ThrowOnError>): RequestResult<ArchiveCollectLensResponses, ArchiveCollectLensErrors, ThrowOnError> => (options.client ?? client).post<ArchiveCollectLensResponses, ArchiveCollectLensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/{lens_id}/archive',
    ...options
});

/**
 * Preview Lens
 */
export const previewCollectLens = <ThrowOnError extends boolean = false>(options: Options<PreviewCollectLensData, ThrowOnError>): RequestResult<PreviewCollectLensResponses, PreviewCollectLensErrors, ThrowOnError> => (options.client ?? client).post<PreviewCollectLensResponses, PreviewCollectLensErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/lenses/{lens_id}/preview',
    ...options
});

/**
 * Create New Project
 *
 * Create a new project with basic details.
 */
export const createCollectProject = <ThrowOnError extends boolean = false>(options: Options<CreateCollectProjectData, ThrowOnError>): RequestResult<CreateCollectProjectResponses, CreateCollectProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateCollectProjectResponses, CreateCollectProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Projects By Organization Project
 *
 * Delete all collect projects under an organization project.
 */
export const deleteCollectProjectsByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectProjectsByOrganizationProjectData, ThrowOnError>): RequestResult<DeleteCollectProjectsByOrganizationProjectResponses, DeleteCollectProjectsByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCollectProjectsByOrganizationProjectResponses, DeleteCollectProjectsByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/by-organization-project/{organization_project_id}/',
    ...options
});

/**
 * Reassign Collect Projects By Org Project
 *
 * Reassign all collect projects under an organization project to a new organization.
 */
export const reassignCollectProjectsByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<ReassignCollectProjectsByOrganizationProjectData, ThrowOnError>): RequestResult<ReassignCollectProjectsByOrganizationProjectResponses, ReassignCollectProjectsByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).post<ReassignCollectProjectsByOrganizationProjectResponses, ReassignCollectProjectsByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/reassign-organization/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Project
 *
 * Soft delete a project by internal integer project ID.
 */
export const deleteCollectProject = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectProjectData, ThrowOnError>): RequestResult<DeleteCollectProjectResponses, DeleteCollectProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCollectProjectResponses, DeleteCollectProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/',
    ...options
});

/**
 * Get Project
 *
 * Get project details by internal integer project ID.
 */
export const getCollectProjectById = <ThrowOnError extends boolean = false>(options: Options<GetCollectProjectByIdData, ThrowOnError>): RequestResult<GetCollectProjectByIdResponses, GetCollectProjectByIdErrors, ThrowOnError> => (options.client ?? client).get<GetCollectProjectByIdResponses, GetCollectProjectByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/',
    ...options
});

/**
 * Update Project
 *
 * Update project details by internal integer project ID.
 */
export const updateCollectProject = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectProjectData, ThrowOnError>): RequestResult<UpdateCollectProjectResponses, UpdateCollectProjectErrors, ThrowOnError> => (options.client ?? client).put<UpdateCollectProjectResponses, UpdateCollectProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Project Activity Bins
 *
 * Get binned conversation starts and completions for a live activity chart.
 */
export const getCollectProjectActivityBins = <ThrowOnError extends boolean = false>(options: Options<GetCollectProjectActivityBinsData, ThrowOnError>): RequestResult<GetCollectProjectActivityBinsResponses, GetCollectProjectActivityBinsErrors, ThrowOnError> => (options.client ?? client).get<GetCollectProjectActivityBinsResponses, GetCollectProjectActivityBinsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/activity-bins/',
    ...options
});

/**
 * Get Project Activity Summary
 *
 * Get lightweight conversation activity counts for a project.
 *
 * ``include_demo`` also returns the completed demo conversations, which
 * the totals never include.
 */
export const getCollectProjectActivitySummary = <ThrowOnError extends boolean = false>(options: Options<GetCollectProjectActivitySummaryData, ThrowOnError>): RequestResult<GetCollectProjectActivitySummaryResponses, GetCollectProjectActivitySummaryErrors, ThrowOnError> => (options.client ?? client).get<GetCollectProjectActivitySummaryResponses, GetCollectProjectActivitySummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/activity-summary/',
    ...options
});

/**
 * Archive Project
 *
 * Archive or unarchive a project.
 */
export const archiveCollectProject = <ThrowOnError extends boolean = false>(options: Options<ArchiveCollectProjectData, ThrowOnError>): RequestResult<ArchiveCollectProjectResponses, ArchiveCollectProjectErrors, ThrowOnError> => (options.client ?? client).post<ArchiveCollectProjectResponses, ArchiveCollectProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/archive/',
    ...options
});

/**
 * Close Project
 *
 * Close the project (interview closed).
 */
export const closeCollectProject = <ThrowOnError extends boolean = false>(options: Options<CloseCollectProjectData, ThrowOnError>): RequestResult<CloseCollectProjectResponses, CloseCollectProjectErrors, ThrowOnError> => (options.client ?? client).post<CloseCollectProjectResponses, CloseCollectProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/close/',
    ...options
});

/**
 * Delete All Project Conversations
 *
 * Soft delete all conversations in this collect project.
 */
export const deleteAllCollectProjectConversations = <ThrowOnError extends boolean = false>(options: Options<DeleteAllCollectProjectConversationsData, ThrowOnError>): RequestResult<DeleteAllCollectProjectConversationsResponses, DeleteAllCollectProjectConversationsErrors, ThrowOnError> => (options.client ?? client).post<DeleteAllCollectProjectConversationsResponses, DeleteAllCollectProjectConversationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/conversations/delete-all/',
    ...options
});

/**
 * Set Project Draft
 *
 * Set project to draft.
 */
export const setCollectProjectDraft = <ThrowOnError extends boolean = false>(options: Options<SetCollectProjectDraftData, ThrowOnError>): RequestResult<SetCollectProjectDraftResponses, SetCollectProjectDraftErrors, ThrowOnError> => (options.client ?? client).post<SetCollectProjectDraftResponses, SetCollectProjectDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/draft/',
    ...options
});

/**
 * Update Project External Id
 *
 * Update the external_id of a project.
 */
export const updateCollectProjectExternalId = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectProjectExternalIdData, ThrowOnError>): RequestResult<UpdateCollectProjectExternalIdResponses, UpdateCollectProjectExternalIdErrors, ThrowOnError> => (options.client ?? client).put<UpdateCollectProjectExternalIdResponses, UpdateCollectProjectExternalIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/external-id/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Image
 *
 * Upload a new image for a project. Accepts a file upload, uploads to GCS, and returns the public URL.
 */
export const uploadCollectProjectImage = <ThrowOnError extends boolean = false>(options: Options<UploadCollectProjectImageData, ThrowOnError>): RequestResult<UploadCollectProjectImageResponses, UploadCollectProjectImageErrors, ThrowOnError> => (options.client ?? client).post<UploadCollectProjectImageResponses, UploadCollectProjectImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/image/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Intro
 *
 * Delete all intro pages for a project.
 */
export const deleteCollectProjectIntro = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectProjectIntroData, ThrowOnError>): RequestResult<DeleteCollectProjectIntroResponses, DeleteCollectProjectIntroErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCollectProjectIntroResponses, DeleteCollectProjectIntroErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/intro/',
    ...options
});

/**
 * Get Intro
 *
 * Get the intro (onboarding) pages for a project.
 */
export const getCollectProjectIntro = <ThrowOnError extends boolean = false>(options: Options<GetCollectProjectIntroData, ThrowOnError>): RequestResult<GetCollectProjectIntroResponses, GetCollectProjectIntroErrors, ThrowOnError> => (options.client ?? client).get<GetCollectProjectIntroResponses, GetCollectProjectIntroErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/intro/',
    ...options
});

/**
 * Create Intro
 *
 * Create intro pages for a project. This will fail if an intro already exists.
 */
export const createCollectProjectIntro = <ThrowOnError extends boolean = false>(options: Options<CreateCollectProjectIntroData, ThrowOnError>): RequestResult<CreateCollectProjectIntroResponses, CreateCollectProjectIntroErrors, ThrowOnError> => (options.client ?? client).post<CreateCollectProjectIntroResponses, CreateCollectProjectIntroErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/intro/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Intro
 *
 * Replace all intro pages for a project.
 */
export const updateCollectProjectIntro = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectProjectIntroData, ThrowOnError>): RequestResult<UpdateCollectProjectIntroResponses, UpdateCollectProjectIntroErrors, ThrowOnError> => (options.client ?? client).put<UpdateCollectProjectIntroResponses, UpdateCollectProjectIntroErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/intro/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Project Language
 *
 * Add a supported language to a project.
 */
export const addCollectProjectLanguage = <ThrowOnError extends boolean = false>(options: Options<AddCollectProjectLanguageData, ThrowOnError>): RequestResult<AddCollectProjectLanguageResponses, AddCollectProjectLanguageErrors, ThrowOnError> => (options.client ?? client).post<AddCollectProjectLanguageResponses, AddCollectProjectLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/languages/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Project Language
 *
 * Remove a language and its translations from a project.
 */
export const removeCollectProjectLanguage = <ThrowOnError extends boolean = false>(options: Options<RemoveCollectProjectLanguageData, ThrowOnError>): RequestResult<RemoveCollectProjectLanguageResponses, RemoveCollectProjectLanguageErrors, ThrowOnError> => (options.client ?? client).delete<RemoveCollectProjectLanguageResponses, RemoveCollectProjectLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/languages/{lang_code}/',
    ...options
});

/**
 * Get Project Translation Status
 *
 * Get translation status for a project.
 */
export const getCollectProjectTranslationStatus = <ThrowOnError extends boolean = false>(options: Options<GetCollectProjectTranslationStatusData, ThrowOnError>): RequestResult<GetCollectProjectTranslationStatusResponses, GetCollectProjectTranslationStatusErrors, ThrowOnError> => (options.client ?? client).get<GetCollectProjectTranslationStatusResponses, GetCollectProjectTranslationStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/localization/status/',
    ...options
});

/**
 * Publish Project
 *
 * Set project to non-draft (published).
 */
export const publishCollectProject = <ThrowOnError extends boolean = false>(options: Options<PublishCollectProjectData, ThrowOnError>): RequestResult<PublishCollectProjectResponses, PublishCollectProjectErrors, ThrowOnError> => (options.client ?? client).post<PublishCollectProjectResponses, PublishCollectProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/publish/',
    ...options
});

/**
 * Reassign Collect Project
 *
 * Reassign a collect project to a new organization project.
 */
export const reassignCollectProject = <ThrowOnError extends boolean = false>(options: Options<ReassignCollectProjectData, ThrowOnError>): RequestResult<ReassignCollectProjectResponses, ReassignCollectProjectErrors, ThrowOnError> => (options.client ?? client).put<ReassignCollectProjectResponses, ReassignCollectProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/reassign-project/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Codes
 */
export const listCollectProjectRecipientCodes = <ThrowOnError extends boolean = false>(options: Options<ListCollectProjectRecipientCodesData, ThrowOnError>): RequestResult<ListCollectProjectRecipientCodesResponses, ListCollectProjectRecipientCodesErrors, ThrowOnError> => (options.client ?? client).get<ListCollectProjectRecipientCodesResponses, ListCollectProjectRecipientCodesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/recipient-codes/',
    ...options
});

/**
 * Create Codes
 */
export const createCollectProjectRecipientCodes = <ThrowOnError extends boolean = false>(options: Options<CreateCollectProjectRecipientCodesData, ThrowOnError>): RequestResult<CreateCollectProjectRecipientCodesResponses, CreateCollectProjectRecipientCodesErrors, ThrowOnError> => (options.client ?? client).post<CreateCollectProjectRecipientCodesResponses, CreateCollectProjectRecipientCodesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/recipient-codes/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Members
 */
export const listCollectProjectRecipientMembers = <ThrowOnError extends boolean = false>(options: Options<ListCollectProjectRecipientMembersData, ThrowOnError>): RequestResult<ListCollectProjectRecipientMembersResponses, ListCollectProjectRecipientMembersErrors, ThrowOnError> => (options.client ?? client).get<ListCollectProjectRecipientMembersResponses, ListCollectProjectRecipientMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/recipient-codes/members/',
    ...options
});

/**
 * Add Members
 */
export const addCollectProjectRecipientMembers = <ThrowOnError extends boolean = false>(options: Options<AddCollectProjectRecipientMembersData, ThrowOnError>): RequestResult<AddCollectProjectRecipientMembersResponses, AddCollectProjectRecipientMembersErrors, ThrowOnError> => (options.client ?? client).post<AddCollectProjectRecipientMembersResponses, AddCollectProjectRecipientMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/recipient-codes/members/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reminder Status
 */
export const getCollectProjectRecipientReminder = <ThrowOnError extends boolean = false>(options: Options<GetCollectProjectRecipientReminderData, ThrowOnError>): RequestResult<GetCollectProjectRecipientReminderResponses, GetCollectProjectRecipientReminderErrors, ThrowOnError> => (options.client ?? client).get<GetCollectProjectRecipientReminderResponses, GetCollectProjectRecipientReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/recipient-codes/remind/',
    ...options
});

/**
 * Remind
 *
 * Remind everyone who hasn't responded, chosen by the server after replying.
 *
 * Privacy invariant INV-6: nothing before the response reads participation, so
 * its body, status, headers and timing are the same whoever is selected. See
 * docs/collect-recipient-privacy-invariants.md and test_recipient_sending.py.
 */
export const remindCollectProjectRecipients = <ThrowOnError extends boolean = false>(options: Options<RemindCollectProjectRecipientsData, ThrowOnError>): RequestResult<RemindCollectProjectRecipientsResponses, RemindCollectProjectRecipientsErrors, ThrowOnError> => (options.client ?? client).post<RemindCollectProjectRecipientsResponses, RemindCollectProjectRecipientsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/recipient-codes/remind/',
    ...options
});

/**
 * Send Invitations
 *
 * Email everyone not yet invited, while the editor waits (L6).
 */
export const sendCollectProjectRecipientInvitations = <ThrowOnError extends boolean = false>(options: Options<SendCollectProjectRecipientInvitationsData, ThrowOnError>): RequestResult<SendCollectProjectRecipientInvitationsResponses, SendCollectProjectRecipientInvitationsErrors, ThrowOnError> => (options.client ?? client).post<SendCollectProjectRecipientInvitationsResponses, SendCollectProjectRecipientInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/recipient-codes/send/',
    ...options
});

/**
 * Resend Invitation
 *
 * Send one invited person their invitation again, whatever their status (L7).
 */
export const resendCollectProjectRecipientInvitation = <ThrowOnError extends boolean = false>(options: Options<ResendCollectProjectRecipientInvitationData, ThrowOnError>): RequestResult<ResendCollectProjectRecipientInvitationResponses, ResendCollectProjectRecipientInvitationErrors, ThrowOnError> => (options.client ?? client).post<ResendCollectProjectRecipientInvitationResponses, ResendCollectProjectRecipientInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/recipient-codes/{recipient_id}/resend/',
    ...options
});

/**
 * Revoke Code
 */
export const revokeCollectProjectRecipientCode = <ThrowOnError extends boolean = false>(options: Options<RevokeCollectProjectRecipientCodeData, ThrowOnError>): RequestResult<RevokeCollectProjectRecipientCodeResponses, RevokeCollectProjectRecipientCodeErrors, ThrowOnError> => (options.client ?? client).post<RevokeCollectProjectRecipientCodeResponses, RevokeCollectProjectRecipientCodeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/recipient-codes/{recipient_id}/revoke/',
    ...options
});

/**
 * Reopen Project
 *
 * Reopen the project (interview open again).
 */
export const reopenCollectProject = <ThrowOnError extends boolean = false>(options: Options<ReopenCollectProjectData, ThrowOnError>): RequestResult<ReopenCollectProjectResponses, ReopenCollectProjectErrors, ThrowOnError> => (options.client ?? client).post<ReopenCollectProjectResponses, ReopenCollectProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/reopen/',
    ...options
});

/**
 * Get Project Statistics
 *
 * Get statistics for a project, using default export settings.
 */
export const getCollectProjectStatistics = <ThrowOnError extends boolean = false>(options: Options<GetCollectProjectStatisticsData, ThrowOnError>): RequestResult<GetCollectProjectStatisticsResponses, GetCollectProjectStatisticsErrors, ThrowOnError> => (options.client ?? client).get<GetCollectProjectStatisticsResponses, GetCollectProjectStatisticsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/statistics/',
    ...options
});

/**
 * List Project Interview Activity Links
 *
 * List active public interview activity links for a project.
 */
export const listCollectProjectInterviewActivityLinks = <ThrowOnError extends boolean = false>(options: Options<ListCollectProjectInterviewActivityLinksData, ThrowOnError>): RequestResult<ListCollectProjectInterviewActivityLinksResponses, ListCollectProjectInterviewActivityLinksErrors, ThrowOnError> => (options.client ?? client).get<ListCollectProjectInterviewActivityLinksResponses, ListCollectProjectInterviewActivityLinksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/stats-links/',
    ...options
});

/**
 * Create Project Interview Activity Link
 *
 * Mint a public interview activity link. Sharing is off until one exists.
 */
export const createCollectProjectInterviewActivityLink = <ThrowOnError extends boolean = false>(options: Options<CreateCollectProjectInterviewActivityLinkData, ThrowOnError>): RequestResult<CreateCollectProjectInterviewActivityLinkResponses, CreateCollectProjectInterviewActivityLinkErrors, ThrowOnError> => (options.client ?? client).post<CreateCollectProjectInterviewActivityLinkResponses, CreateCollectProjectInterviewActivityLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/stats-links/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Project Interview Activity Link
 *
 * Revoke a link. The token stops resolving immediately.
 */
export const revokeCollectProjectInterviewActivityLink = <ThrowOnError extends boolean = false>(options: Options<RevokeCollectProjectInterviewActivityLinkData, ThrowOnError>): RequestResult<RevokeCollectProjectInterviewActivityLinkResponses, RevokeCollectProjectInterviewActivityLinkErrors, ThrowOnError> => (options.client ?? client).delete<RevokeCollectProjectInterviewActivityLinkResponses, RevokeCollectProjectInterviewActivityLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/stats-links/{link_id}/',
    ...options
});

/**
 * Update Project Interview Activity Link
 *
 * Change a link's name, expiry or display mode.
 *
 * Editing rather than recreating keeps the URL, so a printed QR code and any
 * already-shared link stay valid when a session is rescheduled.
 */
export const updateCollectProjectInterviewActivityLink = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectProjectInterviewActivityLinkData, ThrowOnError>): RequestResult<UpdateCollectProjectInterviewActivityLinkResponses, UpdateCollectProjectInterviewActivityLinkErrors, ThrowOnError> => (options.client ?? client).put<UpdateCollectProjectInterviewActivityLinkResponses, UpdateCollectProjectInterviewActivityLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/stats-links/{link_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Template
 *
 * Get the conversation template for a project.
 */
export const getCollectProjectTemplate = <ThrowOnError extends boolean = false>(options: Options<GetCollectProjectTemplateData, ThrowOnError>): RequestResult<GetCollectProjectTemplateResponses, GetCollectProjectTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetCollectProjectTemplateResponses, GetCollectProjectTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/template/',
    ...options
});

/**
 * Update Template
 *
 * Update the conversation template for a project.
 */
export const updateCollectProjectTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectProjectTemplateData, ThrowOnError>): RequestResult<UpdateCollectProjectTemplateResponses, UpdateCollectProjectTemplateErrors, ThrowOnError> => (options.client ?? client).put<UpdateCollectProjectTemplateResponses, UpdateCollectProjectTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/template/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Template Messages
 *
 * Update welcome, questions, and completion messages. Fails if template has categorical questions. Rebuilds question metadata and generic follow-ups.
 */
export const updateCollectProjectTemplateMessages = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectProjectTemplateMessagesData, ThrowOnError>): RequestResult<UpdateCollectProjectTemplateMessagesResponses, UpdateCollectProjectTemplateMessagesErrors, ThrowOnError> => (options.client ?? client).put<UpdateCollectProjectTemplateMessagesResponses, UpdateCollectProjectTemplateMessagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/project/{project_id}/template/messages/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Projects
 *
 * List all non-deleted projects. Optionally include archived.
 */
export const listCollectProjects = <ThrowOnError extends boolean = false>(options: Options<ListCollectProjectsData, ThrowOnError>): RequestResult<ListCollectProjectsResponses, ListCollectProjectsErrors, ThrowOnError> => (options.client ?? client).get<ListCollectProjectsResponses, ListCollectProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/projects/',
    ...options
});

/**
 * Get Context
 */
export const syntheticResponsesGetContext = <ThrowOnError extends boolean = false>(options: Options<SyntheticResponsesGetContextData, ThrowOnError>): RequestResult<SyntheticResponsesGetContextResponses, SyntheticResponsesGetContextErrors, ThrowOnError> => (options.client ?? client).get<SyntheticResponsesGetContextResponses, SyntheticResponsesGetContextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/synthetic-responses/context/',
    ...options
});

/**
 * Generate Personas Endpoint
 */
export const syntheticResponsesGeneratePersonas = <ThrowOnError extends boolean = false>(options: Options<SyntheticResponsesGeneratePersonasData, ThrowOnError>): RequestResult<SyntheticResponsesGeneratePersonasResponses, SyntheticResponsesGeneratePersonasErrors, ThrowOnError> => (options.client ?? client).post<SyntheticResponsesGeneratePersonasResponses, SyntheticResponsesGeneratePersonasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/synthetic-responses/generate-personas/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run Simulation Endpoint
 */
export const syntheticResponsesRun = <ThrowOnError extends boolean = false>(options: Options<SyntheticResponsesRunData, ThrowOnError>): RequestResult<SyntheticResponsesRunResponses, SyntheticResponsesRunErrors, ThrowOnError> => (options.client ?? client).post<SyntheticResponsesRunResponses, SyntheticResponsesRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/collect/management/synthetic-responses/run/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Public Stats
 *
 * Aggregate response activity for one public interview activity link.
 *
 * Unauthenticated by design: the token is the credential. No AuthorizedScope
 * is resolved here, so AuthorizedScopeUsageMiddleware has nothing to assert.
 */
export const getCollectPublicStats = <ThrowOnError extends boolean = false>(options: Options<GetCollectPublicStatsData, ThrowOnError>): RequestResult<GetCollectPublicStatsResponses, GetCollectPublicStatsErrors, ThrowOnError> => (options.client ?? client).get<GetCollectPublicStatsResponses, GetCollectPublicStatsErrors, ThrowOnError>({ url: '/collect/project/stats/{token}/', ...options });

/**
 * Get Project
 */
export const getCollectProject = <ThrowOnError extends boolean = false>(options: Options<GetCollectProjectData, ThrowOnError>): RequestResult<GetCollectProjectResponses, GetCollectProjectErrors, ThrowOnError> => (options.client ?? client).get<GetCollectProjectResponses, GetCollectProjectErrors, ThrowOnError>({ url: '/collect/project/{project_id}/', ...options });

/**
 * Create Discovery Request Endpoint
 *
 * Forward a "Create new discovery" request to support for manual handling.
 */
export const createDiscoveryRequest = <ThrowOnError extends boolean = false>(options: Options<CreateDiscoveryRequestData, ThrowOnError>): RequestResult<CreateDiscoveryRequestResponses, CreateDiscoveryRequestErrors, ThrowOnError> => (options.client ?? client).post<CreateDiscoveryRequestResponses, CreateDiscoveryRequestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery-requests/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Import Context Internal Handler
 */
export const getDiscoveryImportContextInternal = <ThrowOnError extends boolean = false>(options: Options<GetDiscoveryImportContextInternalData, ThrowOnError>): RequestResult<GetDiscoveryImportContextInternalResponses, GetDiscoveryImportContextInternalErrors, ThrowOnError> => (options.client ?? client).get<GetDiscoveryImportContextInternalResponses, GetDiscoveryImportContextInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/internal/organizations/{organization_id}/discoveries/{discovery_id}/import-context/',
    ...options
});

/**
 * Cleanup Discoveries Handler
 */
export const cleanupDiscoveriesByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CleanupDiscoveriesByOrganizationProjectData, ThrowOnError>): RequestResult<CleanupDiscoveriesByOrganizationProjectResponses, CleanupDiscoveriesByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).delete<CleanupDiscoveriesByOrganizationProjectResponses, CleanupDiscoveriesByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/internal/organizations/{organization_id}/organization-projects/{organization_project_id}/discoveries/',
    ...options
});

/**
 * Count Discoveries Handler
 */
export const countDiscoveriesByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CountDiscoveriesByOrganizationProjectData, ThrowOnError>): RequestResult<CountDiscoveriesByOrganizationProjectResponses, CountDiscoveriesByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).get<CountDiscoveriesByOrganizationProjectResponses, CountDiscoveriesByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/internal/organizations/{organization_id}/organization-projects/{organization_project_id}/discoveries/counts/',
    ...options
});

/**
 * Delete Discovery Handler
 */
export const deleteDiscovery = <ThrowOnError extends boolean = false>(options: Options<DeleteDiscoveryData, ThrowOnError>): RequestResult<DeleteDiscoveryResponses, DeleteDiscoveryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDiscoveryResponses, DeleteDiscoveryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/organizations/{organization_id}/discoveries/{discovery_id}/',
    ...options
});

/**
 * Update Discovery Handler
 */
export const updateDiscovery = <ThrowOnError extends boolean = false>(options: Options<UpdateDiscoveryData, ThrowOnError>): RequestResult<UpdateDiscoveryResponses, UpdateDiscoveryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDiscoveryResponses, UpdateDiscoveryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/organizations/{organization_id}/discoveries/{discovery_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Context Handler
 */
export const getDiscoveryContext = <ThrowOnError extends boolean = false>(options: Options<GetDiscoveryContextData, ThrowOnError>): RequestResult<GetDiscoveryContextResponses, GetDiscoveryContextErrors, ThrowOnError> => (options.client ?? client).get<GetDiscoveryContextResponses, GetDiscoveryContextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/organizations/{organization_id}/discoveries/{discovery_id}/context/',
    ...options
});

/**
 * Patch Context Handler
 */
export const patchDiscoveryContext = <ThrowOnError extends boolean = false>(options: Options<PatchDiscoveryContextData, ThrowOnError>): RequestResult<PatchDiscoveryContextResponses, PatchDiscoveryContextErrors, ThrowOnError> => (options.client ?? client).patch<PatchDiscoveryContextResponses, PatchDiscoveryContextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/organizations/{organization_id}/discoveries/{discovery_id}/context/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign Member Handler
 */
export const assignDiscoveryMember = <ThrowOnError extends boolean = false>(options: Options<AssignDiscoveryMemberData, ThrowOnError>): RequestResult<AssignDiscoveryMemberResponses, AssignDiscoveryMemberErrors, ThrowOnError> => (options.client ?? client).put<AssignDiscoveryMemberResponses, AssignDiscoveryMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/organizations/{organization_id}/discoveries/{discovery_id}/members/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unassign Member Handler
 */
export const unassignDiscoveryMember = <ThrowOnError extends boolean = false>(options: Options<UnassignDiscoveryMemberData, ThrowOnError>): RequestResult<UnassignDiscoveryMemberResponses, UnassignDiscoveryMemberErrors, ThrowOnError> => (options.client ?? client).delete<UnassignDiscoveryMemberResponses, UnassignDiscoveryMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/organizations/{organization_id}/discoveries/{discovery_id}/members/{item_type}/{item_id}/',
    ...options
});

/**
 * List Discoveries Handler
 */
export const listDiscoveriesForOrgProject = <ThrowOnError extends boolean = false>(options: Options<ListDiscoveriesForOrgProjectData, ThrowOnError>): RequestResult<ListDiscoveriesForOrgProjectResponses, ListDiscoveriesForOrgProjectErrors, ThrowOnError> => (options.client ?? client).get<ListDiscoveriesForOrgProjectResponses, ListDiscoveriesForOrgProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/organizations/{organization_id}/organization-projects/{organization_project_id}/discoveries/',
    ...options
});

/**
 * Create Discovery Handler
 */
export const createDiscoveryInOrgProject = <ThrowOnError extends boolean = false>(options: Options<CreateDiscoveryInOrgProjectData, ThrowOnError>): RequestResult<CreateDiscoveryInOrgProjectResponses, CreateDiscoveryInOrgProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateDiscoveryInOrgProjectResponses, CreateDiscoveryInOrgProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/discovery/management/organizations/{organization_id}/organization-projects/{organization_project_id}/discoveries/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Health Check
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthGetData, ThrowOnError>): RequestResult<HealthCheckHealthGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError>({ url: '/health/', ...options });

/**
 * Ensure shared E2E anonymous voting canvases
 */
export const ensureE2eAnonymousVotingCanvases = <ThrowOnError extends boolean = false>(options: Options<EnsureE2eAnonymousVotingCanvasesData, ThrowOnError>): RequestResult<EnsureE2eAnonymousVotingCanvasesResponses, EnsureE2eAnonymousVotingCanvasesErrors, ThrowOnError> => (options.client ?? client).post<EnsureE2eAnonymousVotingCanvasesResponses, EnsureE2eAnonymousVotingCanvasesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/fixtures/anonymous-voting-canvases/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or resume a status-only analysis job fixture
 */
export const createLoadTestAnalysisStatusFixture = <ThrowOnError extends boolean = false>(options: Options<CreateLoadTestAnalysisStatusFixtureData, ThrowOnError>): RequestResult<CreateLoadTestAnalysisStatusFixtureResponses, CreateLoadTestAnalysisStatusFixtureErrors, ThrowOnError> => (options.client ?? client).post<CreateLoadTestAnalysisStatusFixtureResponses, CreateLoadTestAnalysisStatusFixtureErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/load-test/analysis-fixtures/jobs/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Advance a status-only analysis job fixture
 */
export const advanceLoadTestAnalysisStatusFixture = <ThrowOnError extends boolean = false>(options: Options<AdvanceLoadTestAnalysisStatusFixtureData, ThrowOnError>): RequestResult<AdvanceLoadTestAnalysisStatusFixtureResponses, AdvanceLoadTestAnalysisStatusFixtureErrors, ThrowOnError> => (options.client ?? client).post<AdvanceLoadTestAnalysisStatusFixtureResponses, AdvanceLoadTestAnalysisStatusFixtureErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/load-test/analysis-fixtures/jobs/{job_id}/advance/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate compact-analysis corpus export without starting analysis
 */
export const validateLoadTestCompactCorpus = <ThrowOnError extends boolean = false>(options: Options<ValidateLoadTestCompactCorpusData, ThrowOnError>): RequestResult<ValidateLoadTestCompactCorpusResponses, ValidateLoadTestCompactCorpusErrors, ThrowOnError> => (options.client ?? client).post<ValidateLoadTestCompactCorpusResponses, ValidateLoadTestCompactCorpusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/load-test/analysis-fixtures/validate-compact-corpus/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create an immutable provider-capacity load-test run manifest
 */
export const createProviderTestRun = <ThrowOnError extends boolean = false>(options: Options<CreateProviderTestRunData, ThrowOnError>): RequestResult<CreateProviderTestRunResponses, CreateProviderTestRunErrors, ThrowOnError> => (options.client ?? client).post<CreateProviderTestRunResponses, CreateProviderTestRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/load-test/provider-test-runs/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Inspect a provider-capacity load-test run manifest and admissions
 */
export const getProviderTestRun = <ThrowOnError extends boolean = false>(options: Options<GetProviderTestRunData, ThrowOnError>): RequestResult<GetProviderTestRunResponses, GetProviderTestRunErrors, ThrowOnError> => (options.client ?? client).get<GetProviderTestRunResponses, GetProviderTestRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/load-test/provider-test-runs/{run_id}/',
    ...options
});

/**
 * Transition provider-capacity load-test run lifecycle state
 */
export const updateProviderTestRunState = <ThrowOnError extends boolean = false>(options: Options<UpdateProviderTestRunStateData, ThrowOnError>): RequestResult<UpdateProviderTestRunStateResponses, UpdateProviderTestRunStateErrors, ThrowOnError> => (options.client ?? client).post<UpdateProviderTestRunStateResponses, UpdateProviderTestRunStateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/load-test/provider-test-runs/{run_id}/state/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admit an idempotent provider-capacity load-test compact analysis start
 */
export const admitProviderTestTargetStart = <ThrowOnError extends boolean = false>(options: Options<AdmitProviderTestTargetStartData, ThrowOnError>): RequestResult<AdmitProviderTestTargetStartResponses, AdmitProviderTestTargetStartErrors, ThrowOnError> => (options.client ?? client).post<AdmitProviderTestTargetStartResponses, AdmitProviderTestTargetStartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/load-test/provider-test-runs/{run_id}/targets/{target_id}/start/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or resume a completed public report fixture
 */
export const createLoadTestReportFixture = <ThrowOnError extends boolean = false>(options: Options<CreateLoadTestReportFixtureData, ThrowOnError>): RequestResult<CreateLoadTestReportFixtureResponses, CreateLoadTestReportFixtureErrors, ThrowOnError> => (options.client ?? client).post<CreateLoadTestReportFixtureResponses, CreateLoadTestReportFixtureErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/load-test/report-fixtures/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Facilitation Session
 */
export const getFacilitationSession = <ThrowOnError extends boolean = false>(options: Options<GetFacilitationSessionData, ThrowOnError>): RequestResult<GetFacilitationSessionResponses, GetFacilitationSessionErrors, ThrowOnError> => (options.client ?? client).get<GetFacilitationSessionResponses, GetFacilitationSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/',
    ...options
});

/**
 * Save Facilitation Session Content
 *
 * Save the agenda of a session that owns its content (409 when attached).
 */
export const saveFacilitationSessionContent = <ThrowOnError extends boolean = false>(options: Options<SaveFacilitationSessionContentData, ThrowOnError>): RequestResult<SaveFacilitationSessionContentResponses, SaveFacilitationSessionContentErrors, ThrowOnError> => (options.client ?? client).put<SaveFacilitationSessionContentResponses, SaveFacilitationSessionContentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/content/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Facilitation Session Demo
 *
 * Run the agenda as a demo, with stand-in choices and phone targets.
 */
export const getFacilitationSessionDemo = <ThrowOnError extends boolean = false>(options: Options<GetFacilitationSessionDemoData, ThrowOnError>): RequestResult<GetFacilitationSessionDemoResponses, GetFacilitationSessionDemoErrors, ThrowOnError> => (options.client ?? client).get<GetFacilitationSessionDemoResponses, GetFacilitationSessionDemoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/demo/',
    ...options
});

/**
 * Detach Facilitation Session
 *
 * Leave the rollout for good; the session copies its agenda to edit freely.
 *
 * Superadmins always may. Others as the organization's
 * ``access.session_detach`` setting allows: ``none`` (default),
 * ``org_admin``, or ``facilitator`` (org admins and the session's own
 * facilitator).
 */
export const detachFacilitationSession = <ThrowOnError extends boolean = false>(options: Options<DetachFacilitationSessionData, ThrowOnError>): RequestResult<DetachFacilitationSessionResponses, DetachFacilitationSessionErrors, ThrowOnError> => (options.client ?? client).post<DetachFacilitationSessionResponses, DetachFacilitationSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/detach/',
    ...options
});

/**
 * Completion
 */
export const setSessionFacilitationCompletion = <ThrowOnError extends boolean = false>(options: Options<SetSessionFacilitationCompletionData, ThrowOnError>): RequestResult<SetSessionFacilitationCompletionResponses, SetSessionFacilitationCompletionErrors, ThrowOnError> => (options.client ?? client).post<SetSessionFacilitationCompletionResponses, SetSessionFacilitationCompletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/facilitation-completion/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * State
 */
export const getSessionFacilitationState = <ThrowOnError extends boolean = false>(options: Options<GetSessionFacilitationStateData, ThrowOnError>): RequestResult<GetSessionFacilitationStateResponses, GetSessionFacilitationStateErrors, ThrowOnError> => (options.client ?? client).get<GetSessionFacilitationStateResponses, GetSessionFacilitationStateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/facilitation-state/',
    ...options
});

/**
 * Faq
 */
export const getSessionFacilitationFaq = <ThrowOnError extends boolean = false>(options: Options<GetSessionFacilitationFaqData, ThrowOnError>): RequestResult<GetSessionFacilitationFaqResponses, GetSessionFacilitationFaqErrors, ThrowOnError> => (options.client ?? client).get<GetSessionFacilitationFaqResponses, GetSessionFacilitationFaqErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/faq/',
    ...options
});

/**
 * Upload Facilitation Session Image
 *
 * Upload an image for the content items of a session that owns its agenda.
 */
export const uploadFacilitationSessionImage = <ThrowOnError extends boolean = false>(options: Options<UploadFacilitationSessionImageData, ThrowOnError>): RequestResult<UploadFacilitationSessionImageResponses, UploadFacilitationSessionImageErrors, ThrowOnError> => (options.client ?? client).post<UploadFacilitationSessionImageResponses, UploadFacilitationSessionImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/images/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Break Choice Tie
 *
 * Take options tied at a per-choice block's cut-off; the choice is then
 * final and the block's runs start.
 *
 * 409 ``choices_final`` once chosen, ``count_not_ready`` before the count;
 * 422 when the options do not fill exactly the places left.
 */
export const breakFacilitationSessionChoiceTie = <ThrowOnError extends boolean = false>(options: Options<BreakFacilitationSessionChoiceTieData, ThrowOnError>): RequestResult<BreakFacilitationSessionChoiceTieResponses, BreakFacilitationSessionChoiceTieErrors, ThrowOnError> => (options.client ?? client).put<BreakFacilitationSessionChoiceTieResponses, BreakFacilitationSessionChoiceTieErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/items/{item_key}/choices/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Close Vote Round
 *
 * Close the round; a round that is not live is returned unchanged.
 */
export const closeFacilitationSessionVoteRound = <ThrowOnError extends boolean = false>(options: Options<CloseFacilitationSessionVoteRoundData, ThrowOnError>): RequestResult<CloseFacilitationSessionVoteRoundResponses, CloseFacilitationSessionVoteRoundErrors, ThrowOnError> => (options.client ?? client).post<CloseFacilitationSessionVoteRoundResponses, CloseFacilitationSessionVoteRoundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/items/{item_key}/voting/close/',
    ...options
});

/**
 * Start Vote Round
 *
 * Open voting on the synthesis this vote slide shows, with the kit
 * item's settings. A live round is returned unchanged; a closed one
 * reopens. 409 ``analysis_not_ready`` before there is a synthesis.
 */
export const startFacilitationSessionVoteRound = <ThrowOnError extends boolean = false>(options: Options<StartFacilitationSessionVoteRoundData, ThrowOnError>): RequestResult<StartFacilitationSessionVoteRoundResponses, StartFacilitationSessionVoteRoundErrors, ThrowOnError> => (options.client ?? client).post<StartFacilitationSessionVoteRoundResponses, StartFacilitationSessionVoteRoundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/items/{item_key}/voting/start/',
    ...options
});

/**
 * Get Worksheet
 *
 * The stored rows; none before the first Fill or save.
 */
export const getFacilitationSessionWorksheet = <ThrowOnError extends boolean = false>(options: Options<GetFacilitationSessionWorksheetData, ThrowOnError>): RequestResult<GetFacilitationSessionWorksheetResponses, GetFacilitationSessionWorksheetErrors, ThrowOnError> => (options.client ?? client).get<GetFacilitationSessionWorksheetResponses, GetFacilitationSessionWorksheetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/items/{item_key}/worksheet/',
    ...options
});

/**
 * Save Worksheet
 *
 * Replace the rows; ``from``, ``question`` and ``votes`` are kept as sent.
 */
export const saveFacilitationSessionWorksheet = <ThrowOnError extends boolean = false>(options: Options<SaveFacilitationSessionWorksheetData, ThrowOnError>): RequestResult<SaveFacilitationSessionWorksheetResponses, SaveFacilitationSessionWorksheetErrors, ThrowOnError> => (options.client ?? client).put<SaveFacilitationSessionWorksheetResponses, SaveFacilitationSessionWorksheetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/items/{item_key}/worksheet/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fill Worksheet
 *
 * Compute the rows from the votes now and overwrite the stored ones.
 */
export const fillFacilitationSessionWorksheet = <ThrowOnError extends boolean = false>(options: Options<FillFacilitationSessionWorksheetData, ThrowOnError>): RequestResult<FillFacilitationSessionWorksheetResponses, FillFacilitationSessionWorksheetErrors, ThrowOnError> => (options.client ?? client).post<FillFacilitationSessionWorksheetResponses, FillFacilitationSessionWorksheetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/items/{item_key}/worksheet/fill/',
    ...options
});

/**
 * List Facilitation Session Prompt Options
 *
 * The analysis prompts an interview item of the agenda can name.
 */
export const listFacilitationSessionPromptOptions = <ThrowOnError extends boolean = false>(options: Options<ListFacilitationSessionPromptOptionsData, ThrowOnError>): RequestResult<ListFacilitationSessionPromptOptionsResponses, ListFacilitationSessionPromptOptionsErrors, ThrowOnError> => (options.client ?? client).get<ListFacilitationSessionPromptOptionsResponses, ListFacilitationSessionPromptOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/prompt-options/',
    ...options
});

/**
 * Resources
 *
 * The workshop's resources, each with a link to download or open it.
 */
export const listSessionResources = <ThrowOnError extends boolean = false>(options: Options<ListSessionResourcesData, ThrowOnError>): RequestResult<ListSessionResourcesResponses, ListSessionResourcesErrors, ThrowOnError> => (options.client ?? client).get<ListSessionResourcesResponses, ListSessionResourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/resources/',
    ...options
});

/**
 * Set Results Source
 *
 * Point a results item at any Discovery of the organization, or clear it.
 */
export const setFacilitationSessionResultsSource = <ThrowOnError extends boolean = false>(options: Options<SetFacilitationSessionResultsSourceData, ThrowOnError>): RequestResult<SetFacilitationSessionResultsSourceResponses, SetFacilitationSessionResultsSourceErrors, ThrowOnError> => (options.client ?? client).put<SetFacilitationSessionResultsSourceResponses, SetFacilitationSessionResultsSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/results-sources/{item_key}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Steps
 */
export const getSessionFacilitationSteps = <ThrowOnError extends boolean = false>(options: Options<GetSessionFacilitationStepsData, ThrowOnError>): RequestResult<GetSessionFacilitationStepsResponses, GetSessionFacilitationStepsErrors, ThrowOnError> => (options.client ?? client).get<GetSessionFacilitationStepsResponses, GetSessionFacilitationStepsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/steps/',
    ...options
});

/**
 * Support
 */
export const getSessionFacilitationSupport = <ThrowOnError extends boolean = false>(options: Options<GetSessionFacilitationSupportData, ThrowOnError>): RequestResult<GetSessionFacilitationSupportResponses, GetSessionFacilitationSupportErrors, ThrowOnError> => (options.client ?? client).get<GetSessionFacilitationSupportResponses, GetSessionFacilitationSupportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/support/',
    ...options
});

/**
 * Reset
 */
export const resetSessionUnderstanding = <ThrowOnError extends boolean = false>(options: Options<ResetSessionUnderstandingData, ThrowOnError>): RequestResult<ResetSessionUnderstandingResponses, ResetSessionUnderstandingErrors, ThrowOnError> => (options.client ?? client).delete<ResetSessionUnderstandingResponses, ResetSessionUnderstandingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/understanding/{step_id}/',
    ...options
});

/**
 * Mark
 */
export const markSessionUnderstanding = <ThrowOnError extends boolean = false>(options: Options<MarkSessionUnderstandingData, ThrowOnError>): RequestResult<MarkSessionUnderstandingResponses, MarkSessionUnderstandingErrors, ThrowOnError> => (options.client ?? client).put<MarkSessionUnderstandingResponses, MarkSessionUnderstandingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/facilitation-sessions/{session_id}/understanding/{step_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Kit Categories
 */
export const listKitCategories = <ThrowOnError extends boolean = false>(options?: Options<ListKitCategoriesData, ThrowOnError>): RequestResult<ListKitCategoriesResponses, ListKitCategoriesErrors, ThrowOnError> => (options?.client ?? client).get<ListKitCategoriesResponses, ListKitCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kit-categories/',
    ...options
});

/**
 * Create Kit Category
 */
export const createKitCategory = <ThrowOnError extends boolean = false>(options: Options<CreateKitCategoryData, ThrowOnError>): RequestResult<CreateKitCategoryResponses, CreateKitCategoryErrors, ThrowOnError> => (options.client ?? client).post<CreateKitCategoryResponses, CreateKitCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kit-categories/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Kit Category
 */
export const deleteKitCategory = <ThrowOnError extends boolean = false>(options: Options<DeleteKitCategoryData, ThrowOnError>): RequestResult<DeleteKitCategoryResponses, DeleteKitCategoryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteKitCategoryResponses, DeleteKitCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kit-categories/{category_id}/',
    ...options
});

/**
 * Update Kit Category
 */
export const updateKitCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateKitCategoryData, ThrowOnError>): RequestResult<UpdateKitCategoryResponses, UpdateKitCategoryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateKitCategoryResponses, UpdateKitCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kit-categories/{category_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Kits
 */
export const listKits = <ThrowOnError extends boolean = false>(options?: Options<ListKitsData, ThrowOnError>): RequestResult<ListKitsResponses, ListKitsErrors, ThrowOnError> => (options?.client ?? client).get<ListKitsResponses, ListKitsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/',
    ...options
});

/**
 * Create Global Kit
 */
export const createGlobalKit = <ThrowOnError extends boolean = false>(options: Options<CreateGlobalKitData, ThrowOnError>): RequestResult<CreateGlobalKitResponses, CreateGlobalKitErrors, ThrowOnError> => (options.client ?? client).post<CreateGlobalKitResponses, CreateGlobalKitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Kit
 */
export const getKit = <ThrowOnError extends boolean = false>(options: Options<GetKitData, ThrowOnError>): RequestResult<GetKitResponses, GetKitErrors, ThrowOnError> => (options.client ?? client).get<GetKitResponses, GetKitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/',
    ...options
});

/**
 * Update Kit
 */
export const updateKit = <ThrowOnError extends boolean = false>(options: Options<UpdateKitData, ThrowOnError>): RequestResult<UpdateKitResponses, UpdateKitErrors, ThrowOnError> => (options.client ?? client).patch<UpdateKitResponses, UpdateKitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Discard Kit Draft
 *
 * Delete the draft; the kit goes back to its latest published version.
 */
export const discardKitDraft = <ThrowOnError extends boolean = false>(options: Options<DiscardKitDraftData, ThrowOnError>): RequestResult<DiscardKitDraftResponses, DiscardKitDraftErrors, ThrowOnError> => (options.client ?? client).delete<DiscardKitDraftResponses, DiscardKitDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/draft/',
    ...options
});

/**
 * Get Kit Draft
 */
export const getKitDraft = <ThrowOnError extends boolean = false>(options: Options<GetKitDraftData, ThrowOnError>): RequestResult<GetKitDraftResponses, GetKitDraftErrors, ThrowOnError> => (options.client ?? client).get<GetKitDraftResponses, GetKitDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/draft/',
    ...options
});

/**
 * Create Kit Draft
 *
 * A new draft from the latest published version.
 */
export const createKitDraft = <ThrowOnError extends boolean = false>(options: Options<CreateKitDraftData, ThrowOnError>): RequestResult<CreateKitDraftResponses, CreateKitDraftErrors, ThrowOnError> => (options.client ?? client).post<CreateKitDraftResponses, CreateKitDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/draft/',
    ...options
});

/**
 * Save Kit Draft
 *
 * Autosave the whole draft; a stale ``lock_version`` is rejected (409).
 */
export const saveKitDraft = <ThrowOnError extends boolean = false>(options: Options<SaveKitDraftData, ThrowOnError>): RequestResult<SaveKitDraftResponses, SaveKitDraftErrors, ThrowOnError> => (options.client ?? client).put<SaveKitDraftResponses, SaveKitDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/draft/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish Kit Draft
 *
 * Validate the draft and freeze it as the next published version.
 *
 * Existing rollouts stay pinned until an admin explicitly updates them.
 */
export const publishKitDraft = <ThrowOnError extends boolean = false>(options: Options<PublishKitDraftData, ThrowOnError>): RequestResult<PublishKitDraftResponses, PublishKitDraftErrors, ThrowOnError> => (options.client ?? client).post<PublishKitDraftResponses, PublishKitDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/draft/publish/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Kit Home Template
 *
 * What a new home starts with: Getting started's home in the kit's language.
 *
 * 404 before the built-in kits are imported; the editor then uses its own defaults.
 */
export const getKitHomeTemplate = <ThrowOnError extends boolean = false>(options: Options<GetKitHomeTemplateData, ThrowOnError>): RequestResult<GetKitHomeTemplateResponses, GetKitHomeTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetKitHomeTemplateResponses, GetKitHomeTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/home-template/',
    ...options
});

/**
 * Upload Kit Image
 *
 * Upload an image for the kit's content items; the URL goes into the draft.
 */
export const uploadKitImage = <ThrowOnError extends boolean = false>(options: Options<UploadKitImageData, ThrowOnError>): RequestResult<UploadKitImageResponses, UploadKitImageErrors, ThrowOnError> => (options.client ?? client).post<UploadKitImageResponses, UploadKitImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/images/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Kit Interview Template
 *
 * What a new interview item starts with, in the kit's language.
 */
export const getKitInterviewTemplate = <ThrowOnError extends boolean = false>(options: Options<GetKitInterviewTemplateData, ThrowOnError>): RequestResult<GetKitInterviewTemplateResponses, GetKitInterviewTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetKitInterviewTemplateResponses, GetKitInterviewTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/interview-template/',
    ...options
});

/**
 * List Kit Org Access
 */
export const listKitOrgAccess = <ThrowOnError extends boolean = false>(options: Options<ListKitOrgAccessData, ThrowOnError>): RequestResult<ListKitOrgAccessResponses, ListKitOrgAccessErrors, ThrowOnError> => (options.client ?? client).get<ListKitOrgAccessResponses, ListKitOrgAccessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/org-access/',
    ...options
});

/**
 * Replace Kit Org Access
 */
export const replaceKitOrgAccess = <ThrowOnError extends boolean = false>(options: Options<ReplaceKitOrgAccessData, ThrowOnError>): RequestResult<ReplaceKitOrgAccessResponses, ReplaceKitOrgAccessErrors, ThrowOnError> => (options.client ?? client).put<ReplaceKitOrgAccessResponses, ReplaceKitOrgAccessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/org-access/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Kit Prompt Options
 *
 * The analysis prompts, for editors of a global kit too, who have no organization.
 */
export const listKitPromptOptions = <ThrowOnError extends boolean = false>(options: Options<ListKitPromptOptionsData, ThrowOnError>): RequestResult<ListKitPromptOptionsResponses, ListKitPromptOptionsErrors, ThrowOnError> => (options.client ?? client).get<ListKitPromptOptionsResponses, ListKitPromptOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/prompt-options/',
    ...options
});

/**
 * List Kit Rollouts
 *
 * The kit's rollouts that are not archived, with the version each is on.
 */
export const listKitRollouts = <ThrowOnError extends boolean = false>(options: Options<ListKitRolloutsData, ThrowOnError>): RequestResult<ListKitRolloutsResponses, ListKitRolloutsErrors, ThrowOnError> => (options.client ?? client).get<ListKitRolloutsResponses, ListKitRolloutsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/rollouts/',
    ...options
});

/**
 * List Kit Versions
 */
export const listKitVersions = <ThrowOnError extends boolean = false>(options: Options<ListKitVersionsData, ThrowOnError>): RequestResult<ListKitVersionsResponses, ListKitVersionsErrors, ThrowOnError> => (options.client ?? client).get<ListKitVersionsResponses, ListKitVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/versions/',
    ...options
});

/**
 * Get Kit Version
 */
export const getKitVersion = <ThrowOnError extends boolean = false>(options: Options<GetKitVersionData, ThrowOnError>): RequestResult<GetKitVersionResponses, GetKitVersionErrors, ThrowOnError> => (options.client ?? client).get<GetKitVersionResponses, GetKitVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/versions/{number}/',
    ...options
});

/**
 * Get Kit Version Home
 */
export const getKitVersionHome = <ThrowOnError extends boolean = false>(options: Options<GetKitVersionHomeData, ThrowOnError>): RequestResult<GetKitVersionHomeResponses, GetKitVersionHomeErrors, ThrowOnError> => (options.client ?? client).get<GetKitVersionHomeResponses, GetKitVersionHomeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/kits/{kit_id}/versions/{number}/home/',
    ...options
});

/**
 * Get Project Facilitation Session
 *
 * The project's session; 404 for projects without one.
 */
export const getProjectFacilitationSession = <ThrowOnError extends boolean = false>(options: Options<GetProjectFacilitationSessionData, ThrowOnError>): RequestResult<GetProjectFacilitationSessionResponses, GetProjectFacilitationSessionErrors, ThrowOnError> => (options.client ?? client).get<GetProjectFacilitationSessionResponses, GetProjectFacilitationSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organization-projects/{organization_project_id}/facilitation-session/',
    ...options
});

/**
 * Organization Content
 */
export const getOrganizationFacilitationContent = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationFacilitationContentData, ThrowOnError>): RequestResult<GetOrganizationFacilitationContentResponses, GetOrganizationFacilitationContentErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationFacilitationContentResponses, GetOrganizationFacilitationContentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/facilitation-content/',
    ...options
});

/**
 * Organization Edit
 */
export const getOrganizationFacilitationContentForEdit = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationFacilitationContentForEditData, ThrowOnError>): RequestResult<GetOrganizationFacilitationContentForEditResponses, GetOrganizationFacilitationContentForEditErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationFacilitationContentForEditResponses, GetOrganizationFacilitationContentForEditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/facilitation-content/edit/',
    ...options
});

/**
 * Organization Save
 */
export const saveOrganizationFacilitationContent = <ThrowOnError extends boolean = false>(options: Options<SaveOrganizationFacilitationContentData, ThrowOnError>): RequestResult<SaveOrganizationFacilitationContentResponses, SaveOrganizationFacilitationContentErrors, ThrowOnError> => (options.client ?? client).put<SaveOrganizationFacilitationContentResponses, SaveOrganizationFacilitationContentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/facilitation-content/edit/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sessions
 */
export const listFacilitatorSessions = <ThrowOnError extends boolean = false>(options: Options<ListFacilitatorSessionsData, ThrowOnError>): RequestResult<ListFacilitatorSessionsResponses, ListFacilitatorSessionsErrors, ThrowOnError> => (options.client ?? client).get<ListFacilitatorSessionsResponses, ListFacilitatorSessionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/facilitation-sessions/',
    ...options
});

/**
 * Create Standalone Session
 *
 * A session that owns its content: from a kit ("start from kit") or blank.
 *
 * With ``context``, the kit's interview items with ``tailor`` are tailored.
 */
export const createStandaloneSession = <ThrowOnError extends boolean = false>(options: Options<CreateStandaloneSessionData, ThrowOnError>): RequestResult<CreateStandaloneSessionResponses, CreateStandaloneSessionErrors, ThrowOnError> => (options.client ?? client).post<CreateStandaloneSessionResponses, CreateStandaloneSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/facilitation-sessions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Templates
 */
export const listFacilitationTemplates = <ThrowOnError extends boolean = false>(options: Options<ListFacilitationTemplatesData, ThrowOnError>): RequestResult<ListFacilitationTemplatesResponses, ListFacilitationTemplatesErrors, ThrowOnError> => (options.client ?? client).get<ListFacilitationTemplatesResponses, ListFacilitationTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/facilitation-templates/',
    ...options
});

/**
 * Organization Welcome
 */
export const getOrganizationFacilitationWelcome = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationFacilitationWelcomeData, ThrowOnError>): RequestResult<GetOrganizationFacilitationWelcomeResponses, GetOrganizationFacilitationWelcomeErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationFacilitationWelcomeResponses, GetOrganizationFacilitationWelcomeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/facilitation-welcome/',
    ...options
});

/**
 * Organization Faq
 */
export const getOrganizationFacilitationFaq = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationFacilitationFaqData, ThrowOnError>): RequestResult<GetOrganizationFacilitationFaqResponses, GetOrganizationFacilitationFaqErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationFacilitationFaqResponses, GetOrganizationFacilitationFaqErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/faq/',
    ...options
});

/**
 * List Organization Kit Categories
 *
 * The global categories an organization kit may be filed under.
 */
export const listOrganizationKitCategories = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationKitCategoriesData, ThrowOnError>): RequestResult<ListOrganizationKitCategoriesResponses, ListOrganizationKitCategoriesErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationKitCategoriesResponses, ListOrganizationKitCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/kit-categories/',
    ...options
});

/**
 * List Organization Kits
 *
 * Published global kits available to the organization, then its own kits.
 */
export const listOrganizationKits = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationKitsData, ThrowOnError>): RequestResult<ListOrganizationKitsResponses, ListOrganizationKitsErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationKitsResponses, ListOrganizationKitsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/kits/',
    ...options
});

/**
 * Create Organization Kit
 */
export const createOrganizationKit = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationKitData, ThrowOnError>): RequestResult<CreateOrganizationKitResponses, CreateOrganizationKitErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationKitResponses, CreateOrganizationKitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/kits/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Personal Test
 *
 * Remove the caller's test with its project, Interviews and replies.
 */
export const removePersonalTest = <ThrowOnError extends boolean = false>(options: Options<RemovePersonalTestData, ThrowOnError>): RequestResult<RemovePersonalTestResponses, RemovePersonalTestErrors, ThrowOnError> => (options.client ?? client).delete<RemovePersonalTestResponses, RemovePersonalTestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/kits/{kit_id}/personal-test/',
    ...options
});

/**
 * Get Personal Test
 *
 * The caller's active test of the kit; null when there is none.
 */
export const getPersonalTest = <ThrowOnError extends boolean = false>(options: Options<GetPersonalTestData, ThrowOnError>): RequestResult<GetPersonalTestResponses, GetPersonalTestErrors, ThrowOnError> => (options.client ?? client).get<GetPersonalTestResponses, GetPersonalTestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/kits/{kit_id}/personal-test/',
    ...options
});

/**
 * Reset Personal Test
 *
 * Start the caller's disposable test over on the latest kit.
 *
 * Removes the existing test's project and session, then creates a new test.
 */
export const resetPersonalTest = <ThrowOnError extends boolean = false>(options: Options<ResetPersonalTestData, ThrowOnError>): RequestResult<ResetPersonalTestResponses, ResetPersonalTestErrors, ThrowOnError> => (options.client ?? client).post<ResetPersonalTestResponses, ResetPersonalTestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/kits/{kit_id}/personal-test/',
    ...options
});

/**
 * Upload
 */
export const uploadOrganizationResourceFile = <ThrowOnError extends boolean = false>(options: Options<UploadOrganizationResourceFileData, ThrowOnError>): RequestResult<UploadOrganizationResourceFileResponses, UploadOrganizationResourceFileErrors, ThrowOnError> => (options.client ?? client).post<UploadOrganizationResourceFileResponses, UploadOrganizationResourceFileErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/resource-files/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Create Folder
 */
export const createOrganizationResourceFolder = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationResourceFolderData, ThrowOnError>): RequestResult<CreateOrganizationResourceFolderResponses, CreateOrganizationResourceFolderErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResourceFolderResponses, CreateOrganizationResourceFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/resource-folders/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Folder
 */
export const updateOrganizationResourceFolder = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationResourceFolderData, ThrowOnError>): RequestResult<UpdateOrganizationResourceFolderResponses, UpdateOrganizationResourceFolderErrors, ThrowOnError> => (options.client ?? client).put<UpdateOrganizationResourceFolderResponses, UpdateOrganizationResourceFolderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/resource-folders/{folder_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder
 */
export const reorderOrganizationResources = <ThrowOnError extends boolean = false>(options: Options<ReorderOrganizationResourcesData, ThrowOnError>): RequestResult<ReorderOrganizationResourcesResponses, ReorderOrganizationResourcesErrors, ThrowOnError> => (options.client ?? client).put<ReorderOrganizationResourcesResponses, ReorderOrganizationResourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/resource-order/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolved
 */
export const listOrganizationResources = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationResourcesData, ThrowOnError>): RequestResult<ListOrganizationResourcesResponses, ListOrganizationResourcesErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationResourcesResponses, ListOrganizationResourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/resources/',
    ...options
});

/**
 * Create
 */
export const createOrganizationResource = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationResourceData, ThrowOnError>): RequestResult<CreateOrganizationResourceResponses, CreateOrganizationResourceErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResourceResponses, CreateOrganizationResourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/resources/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Library
 */
export const getOrganizationResourceLibrary = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationResourceLibraryData, ThrowOnError>): RequestResult<GetOrganizationResourceLibraryResponses, GetOrganizationResourceLibraryErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationResourceLibraryResponses, GetOrganizationResourceLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/resources/library/',
    ...options
});

/**
 * Update
 */
export const updateOrganizationResource = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationResourceData, ThrowOnError>): RequestResult<UpdateOrganizationResourceResponses, UpdateOrganizationResourceErrors, ThrowOnError> => (options.client ?? client).put<UpdateOrganizationResourceResponses, UpdateOrganizationResourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/resources/{resource_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link
 *
 * One resource with a link to open it, hidden and archived ones included.
 */
export const getOrganizationResourceLink = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationResourceLinkData, ThrowOnError>): RequestResult<GetOrganizationResourceLinkResponses, GetOrganizationResourceLinkErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationResourceLinkResponses, GetOrganizationResourceLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/resources/{resource_id}/link/',
    ...options
});

/**
 * List Rollouts
 */
export const listRollouts = <ThrowOnError extends boolean = false>(options: Options<ListRolloutsData, ThrowOnError>): RequestResult<ListRolloutsResponses, ListRolloutsErrors, ThrowOnError> => (options.client ?? client).get<ListRolloutsResponses, ListRolloutsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/rollouts/',
    ...options
});

/**
 * Create Rollout
 *
 * Roll a kit version out: a Project and session per facilitator, upfront.
 *
 * Each facilitator is created on their own; ``facilitators`` reports those
 * that failed and were rolled back.
 */
export const createRollout = <ThrowOnError extends boolean = false>(options: Options<CreateRolloutData, ThrowOnError>): RequestResult<CreateRolloutResponses, CreateRolloutErrors, ThrowOnError> => (options.client ?? client).post<CreateRolloutResponses, CreateRolloutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/rollouts/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Rollout Facilitator Candidates
 *
 * Members a rollout can give a session: everyone who can enter app-site.
 */
export const listRolloutFacilitatorCandidates = <ThrowOnError extends boolean = false>(options: Options<ListRolloutFacilitatorCandidatesData, ThrowOnError>): RequestResult<ListRolloutFacilitatorCandidatesResponses, ListRolloutFacilitatorCandidatesErrors, ThrowOnError> => (options.client ?? client).get<ListRolloutFacilitatorCandidatesResponses, ListRolloutFacilitatorCandidatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/rollouts/facilitator-candidates/',
    ...options
});

/**
 * Settings
 */
export const getRolloutFacilitationSettings = <ThrowOnError extends boolean = false>(options: Options<GetRolloutFacilitationSettingsData, ThrowOnError>): RequestResult<GetRolloutFacilitationSettingsResponses, GetRolloutFacilitationSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetRolloutFacilitationSettingsResponses, GetRolloutFacilitationSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/rollouts/{rollout_id}/facilitation-settings/',
    ...options
});

/**
 * Settings Save
 */
export const updateRolloutFacilitationSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateRolloutFacilitationSettingsData, ThrowOnError>): RequestResult<UpdateRolloutFacilitationSettingsResponses, UpdateRolloutFacilitationSettingsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateRolloutFacilitationSettingsResponses, UpdateRolloutFacilitationSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/rollouts/{rollout_id}/facilitation-settings/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Self Serve Kits
 *
 * The kits the app-site wizard offers: self-serve, available to the
 * organization and in one of its enabled languages.
 */
export const listSelfServeKits = <ThrowOnError extends boolean = false>(options: Options<ListSelfServeKitsData, ThrowOnError>): RequestResult<ListSelfServeKitsResponses, ListSelfServeKitsErrors, ThrowOnError> => (options.client ?? client).get<ListSelfServeKitsResponses, ListSelfServeKitsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/self-serve-kits/',
    ...options
});

/**
 * Start Self Serve Session
 *
 * The caller's own standalone session from a self-serve kit (the wizard).
 *
 * With ``context``, interviews are tailored and start as drafts. Without it,
 * interviews are published and ready to run. Creates
 * the Project, rolled back if the session cannot be created.
 */
export const startSelfServeSession = <ThrowOnError extends boolean = false>(options: Options<StartSelfServeSessionData, ThrowOnError>): RequestResult<StartSelfServeSessionResponses, StartSelfServeSessionErrors, ThrowOnError> => (options.client ?? client).post<StartSelfServeSessionResponses, StartSelfServeSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/self-serve-sessions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Organization Support
 */
export const getOrganizationFacilitationSupport = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationFacilitationSupportData, ThrowOnError>): RequestResult<GetOrganizationFacilitationSupportResponses, GetOrganizationFacilitationSupportErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationFacilitationSupportResponses, GetOrganizationFacilitationSupportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/organizations/{organization_id}/support/',
    ...options
});

/**
 * Update Rollout
 *
 * Rename the rollout or switch its phase (the facilitator home follows).
 */
export const updateRollout = <ThrowOnError extends boolean = false>(options: Options<UpdateRolloutData, ThrowOnError>): RequestResult<UpdateRolloutResponses, UpdateRolloutErrors, ThrowOnError> => (options.client ?? client).patch<UpdateRolloutResponses, UpdateRolloutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/rollouts/{rollout_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive Rollout
 *
 * Archive (or unarchive) the rollout; its sessions become read-only.
 */
export const archiveRollout = <ThrowOnError extends boolean = false>(options: Options<ArchiveRolloutData, ThrowOnError>): RequestResult<ArchiveRolloutResponses, ArchiveRolloutErrors, ThrowOnError> => (options.client ?? client).post<ArchiveRolloutResponses, ArchiveRolloutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/rollouts/{rollout_id}/archive/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add Rollout Facilitators
 *
 * Create sessions for more facilitators.
 *
 * A facilitator with a session detached from this rollout is reported
 * (``detached_session_exists``) and keeps that session.
 */
export const addRolloutFacilitators = <ThrowOnError extends boolean = false>(options: Options<AddRolloutFacilitatorsData, ThrowOnError>): RequestResult<AddRolloutFacilitatorsResponses, AddRolloutFacilitatorsErrors, ThrowOnError> => (options.client ?? client).post<AddRolloutFacilitatorsResponses, AddRolloutFacilitatorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/rollouts/{rollout_id}/facilitators/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Rollout Move Plan
 *
 * Review wording and content-slide changes in the latest published version.
 */
export const getRolloutMovePlan = <ThrowOnError extends boolean = false>(options: Options<GetRolloutMovePlanData, ThrowOnError>): RequestResult<GetRolloutMovePlanResponses, GetRolloutMovePlanErrors, ThrowOnError> => (options.client ?? client).get<GetRolloutMovePlanResponses, GetRolloutMovePlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/rollouts/{rollout_id}/move-plan/',
    ...options
});

/**
 * Move Rollout
 *
 * Move the rollout as reviewed (409 when the plan changed since).
 *
 * Only wording and existing content slides can change. All open Interviews
 * update together; closed Interviews keep their questions.
 */
export const moveRollout = <ThrowOnError extends boolean = false>(options: Options<MoveRolloutData, ThrowOnError>): RequestResult<MoveRolloutResponses, MoveRolloutErrors, ThrowOnError> => (options.client ?? client).post<MoveRolloutResponses, MoveRolloutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/rollouts/{rollout_id}/move/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Rollout Facilitator
 *
 * Keep the session with its Interviews closed, detach it, archive its
 * project or delete its project.
 *
 * Detaching follows the organization's detach setting.
 */
export const removeRolloutFacilitator = <ThrowOnError extends boolean = false>(options: Options<RemoveRolloutFacilitatorData, ThrowOnError>): RequestResult<RemoveRolloutFacilitatorResponses, RemoveRolloutFacilitatorErrors, ThrowOnError> => (options.client ?? client).post<RemoveRolloutFacilitatorResponses, RemoveRolloutFacilitatorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/rollouts/{rollout_id}/sessions/{session_id}/remove/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Rollout Status
 *
 * Rolled out / detached and each facilitator's progress stages.
 */
export const getRolloutStatus = <ThrowOnError extends boolean = false>(options: Options<GetRolloutStatusData, ThrowOnError>): RequestResult<GetRolloutStatusResponses, GetRolloutStatusErrors, ThrowOnError> => (options.client ?? client).get<GetRolloutStatusResponses, GetRolloutStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/rollouts/{rollout_id}/status/',
    ...options
});

/**
 * List Syntheses
 */
export const listSyntheses = <ThrowOnError extends boolean = false>(options: Options<ListSynthesesData, ThrowOnError>): RequestResult<ListSynthesesResponses, ListSynthesesErrors, ThrowOnError> => (options.client ?? client).get<ListSynthesesResponses, ListSynthesesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/',
    ...options
});

/**
 * Create Synthesis
 */
export const createSynthesis = <ThrowOnError extends boolean = false>(options: Options<CreateSynthesisData, ThrowOnError>): RequestResult<CreateSynthesisResponses, CreateSynthesisErrors, ThrowOnError> => (options.client ?? client).post<CreateSynthesisResponses, CreateSynthesisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Syntheses By Organization Project
 */
export const deleteSynthesesByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<DeleteSynthesesByOrganizationProjectData, ThrowOnError>): RequestResult<DeleteSynthesesByOrganizationProjectResponses, DeleteSynthesesByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSynthesesByOrganizationProjectResponses, DeleteSynthesesByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/by-organization-project/{organization_project_id}/',
    ...options
});

/**
 * Reassign Syntheses By Organization Project
 */
export const reassignSynthesesByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<ReassignSynthesesByOrganizationProjectData, ThrowOnError>): RequestResult<ReassignSynthesesByOrganizationProjectResponses, ReassignSynthesesByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).post<ReassignSynthesesByOrganizationProjectResponses, ReassignSynthesesByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/reassign-organization/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Synthesis
 */
export const deleteSynthesis = <ThrowOnError extends boolean = false>(options: Options<DeleteSynthesisData, ThrowOnError>): RequestResult<DeleteSynthesisResponses, DeleteSynthesisErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSynthesisResponses, DeleteSynthesisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/',
    ...options
});

/**
 * Get Synthesis
 */
export const getSynthesis = <ThrowOnError extends boolean = false>(options: Options<GetSynthesisData, ThrowOnError>): RequestResult<GetSynthesisResponses, GetSynthesisErrors, ThrowOnError> => (options.client ?? client).get<GetSynthesisResponses, GetSynthesisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/',
    ...options
});

/**
 * Archive Synthesis
 */
export const archiveSynthesis = <ThrowOnError extends boolean = false>(options: Options<ArchiveSynthesisData, ThrowOnError>): RequestResult<ArchiveSynthesisResponses, ArchiveSynthesisErrors, ThrowOnError> => (options.client ?? client).post<ArchiveSynthesisResponses, ArchiveSynthesisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/archive/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Synthesis Content
 */
export const getSynthesisContent = <ThrowOnError extends boolean = false>(options: Options<GetSynthesisContentData, ThrowOnError>): RequestResult<GetSynthesisContentResponses, GetSynthesisContentErrors, ThrowOnError> => (options.client ?? client).get<GetSynthesisContentResponses, GetSynthesisContentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/content/',
    ...options
});

/**
 * Replace Synthesis Content
 */
export const replaceSynthesisContent = <ThrowOnError extends boolean = false>(options: Options<ReplaceSynthesisContentData, ThrowOnError>): RequestResult<ReplaceSynthesisContentResponses, ReplaceSynthesisContentErrors, ThrowOnError> => (options.client ?? client).put<ReplaceSynthesisContentResponses, ReplaceSynthesisContentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/content/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate discussion questions for each subtheme
 */
export const generateSynthesisDiscussionQuestions = <ThrowOnError extends boolean = false>(options: Options<GenerateSynthesisDiscussionQuestionsData, ThrowOnError>): RequestResult<GenerateSynthesisDiscussionQuestionsResponses, GenerateSynthesisDiscussionQuestionsErrors, ThrowOnError> => (options.client ?? client).post<GenerateSynthesisDiscussionQuestionsResponses, GenerateSynthesisDiscussionQuestionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/discussion-questions/',
    ...options
});

/**
 * Add Synthesis Language
 */
export const addSynthesisLanguage = <ThrowOnError extends boolean = false>(options: Options<AddSynthesisLanguageData, ThrowOnError>): RequestResult<AddSynthesisLanguageResponses, AddSynthesisLanguageErrors, ThrowOnError> => (options.client ?? client).post<AddSynthesisLanguageResponses, AddSynthesisLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/languages/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Synthesis Language
 */
export const removeSynthesisLanguage = <ThrowOnError extends boolean = false>(options: Options<RemoveSynthesisLanguageData, ThrowOnError>): RequestResult<RemoveSynthesisLanguageResponses, RemoveSynthesisLanguageErrors, ThrowOnError> => (options.client ?? client).post<RemoveSynthesisLanguageResponses, RemoveSynthesisLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/languages/{language}/remove/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Synthesis Metadata
 */
export const updateSynthesisMetadata = <ThrowOnError extends boolean = false>(options: Options<UpdateSynthesisMetadataData, ThrowOnError>): RequestResult<UpdateSynthesisMetadataResponses, UpdateSynthesisMetadataErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSynthesisMetadataResponses, UpdateSynthesisMetadataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/metadata/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Publication
 */
export const getSynthesisPublication = <ThrowOnError extends boolean = false>(options: Options<GetSynthesisPublicationData, ThrowOnError>): RequestResult<GetSynthesisPublicationResponses, GetSynthesisPublicationErrors, ThrowOnError> => (options.client ?? client).get<GetSynthesisPublicationResponses, GetSynthesisPublicationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/publication/',
    ...options
});

/**
 * Update Publication
 */
export const updateSynthesisPublication = <ThrowOnError extends boolean = false>(options: Options<UpdateSynthesisPublicationData, ThrowOnError>): RequestResult<UpdateSynthesisPublicationResponses, UpdateSynthesisPublicationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSynthesisPublicationResponses, UpdateSynthesisPublicationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/publication/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate External Id
 */
export const rotateSynthesisExternalId = <ThrowOnError extends boolean = false>(options: Options<RotateSynthesisExternalIdData, ThrowOnError>): RequestResult<RotateSynthesisExternalIdResponses, RotateSynthesisExternalIdErrors, ThrowOnError> => (options.client ?? client).post<RotateSynthesisExternalIdResponses, RotateSynthesisExternalIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/publication/external-id/rotate/',
    ...options
});

/**
 * Reassign Synthesis Project
 */
export const reassignSynthesisProject = <ThrowOnError extends boolean = false>(options: Options<ReassignSynthesisProjectData, ThrowOnError>): RequestResult<ReassignSynthesisProjectResponses, ReassignSynthesisProjectErrors, ThrowOnError> => (options.client ?? client).put<ReassignSynthesisProjectResponses, ReassignSynthesisProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/reassign-project/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Synthesis Internal Report
 */
export const getSynthesisInternalReport = <ThrowOnError extends boolean = false>(options: Options<GetSynthesisInternalReportData, ThrowOnError>): RequestResult<GetSynthesisInternalReportResponses, GetSynthesisInternalReportErrors, ThrowOnError> => (options.client ?? client).get<GetSynthesisInternalReportResponses, GetSynthesisInternalReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/report.md',
    ...options
});

/**
 * List Revisions
 */
export const listSynthesisRevisions = <ThrowOnError extends boolean = false>(options: Options<ListSynthesisRevisionsData, ThrowOnError>): RequestResult<ListSynthesisRevisionsResponses, ListSynthesisRevisionsErrors, ThrowOnError> => (options.client ?? client).get<ListSynthesisRevisionsResponses, ListSynthesisRevisionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/revisions/',
    ...options
});

/**
 * Restore Revision
 */
export const restoreSynthesisRevision = <ThrowOnError extends boolean = false>(options: Options<RestoreSynthesisRevisionData, ThrowOnError>): RequestResult<RestoreSynthesisRevisionResponses, RestoreSynthesisRevisionErrors, ThrowOnError> => (options.client ?? client).post<RestoreSynthesisRevisionResponses, RestoreSynthesisRevisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/revisions/{revision_number}/restore/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Votes Results
 */
export const getSynthesisVotesResults = <ThrowOnError extends boolean = false>(options: Options<GetSynthesisVotesResultsData, ThrowOnError>): RequestResult<GetSynthesisVotesResultsResponses, GetSynthesisVotesResultsErrors, ThrowOnError> => (options.client ?? client).get<GetSynthesisVotesResultsResponses, GetSynthesisVotesResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/votes/results/',
    ...options
});

/**
 * Get Votes Summary
 */
export const getSynthesisVotesSummary = <ThrowOnError extends boolean = false>(options: Options<GetSynthesisVotesSummaryData, ThrowOnError>): RequestResult<GetSynthesisVotesSummaryResponses, GetSynthesisVotesSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetSynthesisVotesSummaryResponses, GetSynthesisVotesSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/votes/summary/',
    ...options
});

/**
 * Close Voting
 */
export const closeSynthesisVoting = <ThrowOnError extends boolean = false>(options: Options<CloseSynthesisVotingData, ThrowOnError>): RequestResult<CloseSynthesisVotingResponses, CloseSynthesisVotingErrors, ThrowOnError> => (options.client ?? client).post<CloseSynthesisVotingResponses, CloseSynthesisVotingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/voting/close/',
    ...options
});

/**
 * Reopen Voting
 */
export const reopenSynthesisVoting = <ThrowOnError extends boolean = false>(options: Options<ReopenSynthesisVotingData, ThrowOnError>): RequestResult<ReopenSynthesisVotingResponses, ReopenSynthesisVotingErrors, ThrowOnError> => (options.client ?? client).post<ReopenSynthesisVotingResponses, ReopenSynthesisVotingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/management/synthesis/{synthesis_id}/voting/reopen/',
    ...options
});

/**
 * List Organization Discoveries Handler
 */
export const listOrganizationDiscoveries = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationDiscoveriesData, ThrowOnError>): RequestResult<ListOrganizationDiscoveriesResponses, ListOrganizationDiscoveriesErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationDiscoveriesResponses, ListOrganizationDiscoveriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organization/management/organizations/{organization_id}/discoveries/',
    ...options
});

/**
 * Get Organization Discovery Handler
 */
export const getOrganizationDiscovery = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationDiscoveryData, ThrowOnError>): RequestResult<GetOrganizationDiscoveryResponses, GetOrganizationDiscoveryErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationDiscoveryResponses, GetOrganizationDiscoveryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organization/management/organizations/{organization_id}/discoveries/{discovery_id}/',
    ...options
});

/**
 * List Organization Analysis Runs
 */
export const listOrganizationAnalysisRuns = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationAnalysisRunsData, ThrowOnError>): RequestResult<ListOrganizationAnalysisRunsResponses, ListOrganizationAnalysisRunsErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationAnalysisRunsResponses, ListOrganizationAnalysisRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{organization_id}/analysis-runs/',
    ...options
});

/**
 * Get Organization Analysis Run Source
 */
export const getOrganizationAnalysisRunSource = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationAnalysisRunSourceData, ThrowOnError>): RequestResult<GetOrganizationAnalysisRunSourceResponses, GetOrganizationAnalysisRunSourceErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationAnalysisRunSourceResponses, GetOrganizationAnalysisRunSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{organization_id}/analysis-runs/{run_id}/source/',
    ...options
});

/**
 * List My Collect Invitations
 */
export const listMyCollectInvitations = <ThrowOnError extends boolean = false>(options: Options<ListMyCollectInvitationsData, ThrowOnError>): RequestResult<ListMyCollectInvitationsResponses, ListMyCollectInvitationsErrors, ThrowOnError> => (options.client ?? client).get<ListMyCollectInvitationsResponses, ListMyCollectInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{organization_id}/my-collect-invitations/',
    ...options
});

/**
 * Delete all syntheses by organization project ID
 */
export const cleanupSynthesesByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CleanupSynthesesByOrganizationProjectData, ThrowOnError>): RequestResult<CleanupSynthesesByOrganizationProjectResponses, CleanupSynthesesByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).delete<CleanupSynthesesByOrganizationProjectResponses, CleanupSynthesesByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/synthesis/cleanup/by-organization-project/{organization_project_id}/',
    ...options
});

/**
 * Count syntheses by organization project ID
 */
export const countSynthesesByOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CountSynthesesByOrganizationProjectData, ThrowOnError>): RequestResult<CountSynthesesByOrganizationProjectResponses, CountSynthesesByOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).get<CountSynthesesByOrganizationProjectResponses, CountSynthesesByOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/synthesis/cleanup/by-organization-project/{organization_project_id}/counts/',
    ...options
});
